import React, { useContext, useEffect, useState } from "react";
import { Container, Row, Dropdown, Button, Form } from "react-bootstrap";
import DropdownButton from "react-bootstrap/DropdownButton";
import { BsToggles } from "react-icons/bs";
import closeIcon from "../../../src/common/assets/images/close-icon.png";
import "./EpisodeStatus.css";
import { FaEllipsisH, FaCog } from "react-icons/fa";
import { toast, ToastContainer } from "react-toastify";
import { BiBarChartSquare, BiLoader, BiMoney } from "react-icons/bi";
import CircularProgress from "@mui/material/CircularProgress";
import magicIcon from "../../common/assets/images/magicIcon.png";
import starsIcon from "../../common/assets/images/starsImg.png";
import drg1Icon from "../../assets/notification-text.png";
import drg2Icon from "../../assets/calendar-check-02.png";
import drg3Icon from "../../assets/pie-chart-04.png";
import drg4Icon from "../../assets/star-01.png";
import Pagination from "react-bootstrap/Pagination";
import { CodeContext } from "../pages/Coder/Coder";
import { useLazyGetData2Query } from "../../store/apiSlice";
import { useSelector, useDispatch } from "react-redux";
import LockOutlineIcon from "@mui/icons-material/LockOutline";
import {
  Box,
  IconButton,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
  Menu,
  MenuItem,
  Drawer,
  Divider,
  Grid,
  Modal,
  Card,
  CardActionArea,
  CardContent,
  OutlinedInput,
  InputLabel,
  FormControl,
  Select,
  TextField,
  Checkbox,
  FormControlLabel,
  Switch,
} from "@mui/material";
import {
  getDocumentViewerData,
  resetEpisodeIdentifierTopassDocumentViewer,
  setDocumentviewerPage,
  setEpisodeIdentifierTopassDocumentViewer,
} from "../DocumentViewer/redux/DocumentViewerSlicer";
// import Select from "react-select";
import {
  getAuditorsFilterOptions,
  getCoderFilterOptions,
  getHealthFundContractFilterOptions,
} from "../../components/Codeworkflow/HealthInsuranceManager/redux/HealthInformationManagerSlicer";
import {
  changeStatus,
  getAuditorViewData,
  updateAuditorPage,
} from "../Codeworkflow/AuditorView/redux/AuditorViewSlicer";
import { Spinner } from "../../utils/Spinner";
import {
  getFilterEpisodeLists,
  selectedEpisodeList,
  setSelectedQueue,
} from "../pages/EpisodeList/redux/EpisodeListSlicer";
import { Loader } from "../../utils/Loader";
import Skeleton from "react-loading-skeleton";
import LdsRoller from "../../utils/LdsRoller";
import DotsLoader from "../../utils/DotsLoader";
import { useLocation, useNavigate } from "react-router-dom";
import { removeCode, viewEmrDmrPas } from "../CodingScreen/Service";
import confirm_tick from "../../common/assets/images/confirm.png";
import {
  fetchEpisodes,
  getAuditResponse,
  resetSelectedMissingNotesOptions,
  setEnableMissingNotes,
  setSelectedMissingNotesOptions,
  getunlockEpisode,
  triggerPallasAlgoCdc,
  resetIsPallasAlgoApplied,
  setIsPallasAlgoApplied,
} from "../pages/Coder/redux/CoderSlicer";
import { fetchCodersData } from "../Codeworkflow/CoderView/redux/CoderScreenSlice";
import { getResponsiveSliceConfig } from "./utils/ResponsiveSliceConfig";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import CloseIcon from "@mui/icons-material/Close";
// In EpisodeStatus.jsx, after the imports, ensure this is imported:
import { showAvailableAuditQueues } from "../Codeworkflow/AuditorView/redux/AuditorViewSlicer";
import { outside } from "semver";
import {
  sendToAuditInfo,
  setandStoreDrgCodeandWeight,
  setClickedEpisodeQueues,
  storeDrgVersionAndData,
} from "./Redux/EpisodeStatusSlice";
import axios from "axios";
// import { setDocumentviewerPage } from "../../components/DocumentViewer/redux/DocumentViewerSlicer"
function useWindowWidth() {
  const [width, setWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return width;
}

const EpisodeStatus = ({
  drgData,
  setDrgData,
  selectedVersion,
  setSelectedVersion,
  allEpisodesListData,
  episodesFilterList,
  isEpisodesLoading,
  waitTillLoad,
  setSkipAcceptApi,
  codingscreendata,
  pasHyperLink,
  setPasHyperLink,
  handleDRGOptions,
  handleDrgInformation,
  handleConfirmDrg,
  isDrgConfirmed,
  acceptedCodes,
  handleEpisodeChange,
  currentEpisode,
  setCurrentEpisode,
  currentStatus,
  setCurrentStatus,
  currentEpisodeNumber,
  setCurrentEpisodeNumber,
  drgConfirmedStatusUpdate,
  setOpenStatusUpdatedModal,
  setSelectedQueueIds,
  selectedAuditorQueueIds,
  setSelectedAuditorQueueIds,
  coderForReviewId,
  setCoderForReviewId,
  auditorForReviewId,
  setAuditorForReviewId,
  handleSendToAudit,
  selectedQueueIds,
  selectedCoderInActionId,
  setSelectedCoderInActionId,
  newlyInsertedCodes,
  setNewlyInsertedCodes,
  resetQueueFromNavigation,
  diagnosisStates,
  deletedCodes,
  setDeletedCodes,
  selectedAuditorId,
  setSelectedAuditorId,
  reviewReason,
  setReviewReason,
  hasDenyConfirmation,
  isStatusUpdated,
  selectedActionType,
  setSelectedActionType,
  showMyActionsDropdown,
  setShowMyActionsDropdown,
  // resetQueueFromNavigationAudit
}) => {
  const width = useWindowWidth();
  const SLICE_CONFIG = getResponsiveSliceConfig(width);
  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.down("lg"));
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const location = useLocation();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("queues");
  const [activeUserTab, setActiveUserTab] = useState("coders");
  const [searchAuditorQueues, setSearchAuditorQueues] = useState("");
  const [hoverIndex, setHoverIndex] = useState(null);
  const [isPasLoading, setIsPasLoading] = useState(false);
  const [showTooltipHover, setShowTooltipHover] = useState("");
  const [auditStatusChangeModal, setAuditStatusChangeModal] = useState(false);
  const [missingNotesModal, setMissingNotesModal] = useState(false);
  // const [clickedEpisodeQueues, setClickedEpisodeQueues] = useState([]);
  const { episodeList } = useSelector((state) => state);
  const codebookusaEnv = process.env.REACT_APP_FLAG_USA;
  const codebooksanEnv = process.env.REACT_APP_FLAG_SAN;
  const codebooksanprodEnv = process.env.REACT_APP_FLAG_SAN_PROD;
    // ✅ read loginUserID (same as CoderView)
  const loginUserID = JSON.parse(sessionStorage.getItem("userId")) || {};
  const handleOpen = (event) => {
    setMobileOpen(true);
  };



  const dispatch = useDispatch();
  const newEpisodeListFilterObj = JSON.parse(sessionStorage.getItem("filters"));
  const currentEpisodeIndex = JSON.parse(
    sessionStorage.getItem("currentEpisodeIndex"),
  );
  const episodeDetailsFromStorage = JSON.parse(
    sessionStorage.getItem("episodeDetails"),
  );
  const [triggerGetData2, { data, error, isLoading }] = useLazyGetData2Query();
  const codersData = useSelector((state) => state.coderscreenqueue.codersData);
  const islockedKeyforepisode = codingscreendata?.data?.meta.is_locked;
  const { enableMissingNotes, selectedMissingNotesOptions } = useSelector(
    (state) => state.coder,
  );
  const auditorNamesandQueues = useSelector(
    (state) => state.coder.auditorNamesandQueues,
  );
  const filteredAuditorQueues = auditorNamesandQueues?.auditor_queues?.filter((queue) =>
    queue.queue_name?.toLowerCase().includes(searchAuditorQueues.toLowerCase())
  );
  const coderNamesInActions = useSelector(
    (state) => state.coder.coderNamesInActions,
  );
  const { auditorViewData, auditorViewDataLoading, auditorViewDataError } =
    useSelector((state) => state.auditorView.auditorViewResponse);
  const isLockedCoder = codingscreendata?.data?.meta?.is_locked;


  const { auditorsFilterOptions } = useSelector((state) => state.healthInsuranceManager);
  const { coderFilterOptions } = useSelector((state) => state.healthInsuranceManager)
  const isFromAccelerate = location.state?.fromAccelerate;
  const currentStatusList = Array.isArray(currentStatus) ? currentStatus : [];
  const {
  auditors,
  queues,
  queuesloading,
 clickedEpisodeQueues
} = useSelector((state) => state.episodeStatus);
const [masterQueues, setMasterQueues] = useState([]);
useEffect(() => {
  if (queues?.length > 0) {
    setMasterQueues(queues);
  }
}, [queues]);
  // ✅ move primary to top ONLY if exists
  const primaryItem = currentStatusList.find((item) => item.is_primary);

  const orderedList = primaryItem
    ? [primaryItem, ...currentStatusList.filter((i) => !i.is_primary)]
    : currentStatusList;

  // ✅ extract ONLY strings
  const list = orderedList.length
    ? orderedList.map((item) => item?.status || "Status")
    : ["Status"];

  const topStatus = list[0];
  const hasMultiple = list.length > 1;
  const statusText = Array.isArray(currentEpisode?.status)
    ? currentEpisode.status.map((item) => item.status).join(", ")
    : currentEpisode?.status || "-";
  const isQueueDisabled = selectedAuditorId;
  const lastCodedEpisode = useSelector((state) => state.episodeList);
  const typeOfPatient = lastCodedEpisode?.selectedEpisode?.type_patient;
  const { selectedQueueworkSpace } = useSelector((state) => state.episodeList);
  console.log(selectedQueueworkSpace,"selectedQueueworkSpace")
  const hasStatus = (statusArray, statusName) =>
    statusArray?.some((s) => s.status === statusName);
  const hasAwaitingAudit = codingscreendata?.data?.meta?.status?.some(
    (item) => item?.status === "Awaiting Audit",
  );
  const allCodesEmpty =
    codingscreendata?.data?.principal_diagnosis?.[0]?.code === null &&
    codingscreendata?.data?.additional_diagnoses?.length === 0 &&
    codingscreendata?.data?.procedure_codes?.length === 0;

  const disableOnHold =
    allCodesEmpty &&
    newlyInsertedCodes.length === 0 &&
    hasStatus(codingscreendata?.data?.meta?.status, "Outstanding");
  const [totalEpisodes, setTotalEpisodes] = useState([]);
  const hasPrincipalError = diagnosisStates?.principal?.some(
    (item) =>
      item?.warning?.is_warning === true &&
      item?.warning?.warning_description
        ?.toLowerCase()
        .includes("invalid/unacceptable principal diagnosis"),
  );
  const currentScreen = sessionStorage?.getItem("currentPage");
  const last_hcp_line_id = sessionStorage?.getItem("last_hcp_line_id");
  const last_epi_identifier = sessionStorage?.getItem("last_epi_identifier");
  const isAuditorDisabled = selectedQueueIds?.length > 0;
  const [searchAuditor, setSearchAuditor] = useState("");
  const [searchQueues, setSearchQueues] = useState("");
  const [searchCoders, setSearchCoders] = useState("");
  const [showAuditQueueModal, setShowAuditQueueModal] = useState(false);
  const [showMissingNotes, setShowMissingNotes] = useState(false);
  const [isLoadingQueues, setIsLoadingQueues] = useState(false);
  const selectedQueue = useSelector((state) => state.CodingScreenSlice);
  const filteredAuditors = auditorsFilterOptions.data.filter((auditor) =>
    auditor.user_name.toLowerCase().includes(searchAuditor.toLowerCase()),
  );
  const {
    data: auditorsData,
    pageNumber,
    hasMore,
    loading
  } = auditorsFilterOptions;
  const {
    data: codersDataOption,
    pageNumber: coderPageNumber,
    hasMore: coderHasMore,
    loading: coderLoading,
  } = coderFilterOptions;
  console.log(coderFilterOptions, "coderFilterOptions");
  const isPallasAlgoApplied = useSelector(
    (state) => state.coder.isPallasAlgoApplied,
  );

  const filteredQueues = auditorNamesandQueues?.auditor_queues?.filter(
    (queue) =>
      queue.queue_name?.toLowerCase().includes(searchQueues.toLowerCase()),
  );

  //  const filteredCoders =
  //   currentScreen === "coderview"
  //     ? coderNamesInActions?.coders?.filter((coder) =>
  //         coder.user_name?.toLowerCase().includes(searchCoders.toLowerCase()),
  //       )
  //     : auditorNamesandQueues?.auditors?.filter((auditor) =>
  //         auditor.user_name.toLowerCase().includes(searchCoders.toLowerCase()),
  //       );

  const filteredCoders =
    codersDataOption?.filter((coder) =>
      coder?.user_name
        ?.toLowerCase()
        .includes(searchCoders.toLowerCase()),
    ) || [];

     const handleAuditorScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;

    const reachedBottom =
      scrollHeight - scrollTop <= clientHeight + 20;

    if (reachedBottom && hasMore && !loading) {
      dispatch(
        getAuditorsFilterOptions({
          search: searchAuditor,
          page_number: pageNumber + 1,
          page_size: 10,
        }),
      );
    }
  };

  const handleCoderScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;

    const reachedBottom =
      scrollHeight - scrollTop <= clientHeight + 20;

    if (
      reachedBottom &&
      coderHasMore &&
      !coderLoading
    ) {
      dispatch(
        getCoderFilterOptions({
          search: searchCoders,
          page_number: coderPageNumber + 1,
          page_size: 10,
        }),
      );
    }
  };
   useEffect(() => {
  if (!showMyActionsDropdown) return;

  const HcpLienId = sessionStorage.getItem("last_hcp_line_id");

  if (activeTab === "auditors" || activeTab === "queues") {
    dispatch(
      sendToAuditInfo({
        hcp_line_id: HcpLienId,
        send_to_audit_key: activeTab,
        search_key: searchAuditor,
        page_number: 1,
        page_size: 10,
      })
    );
  }
}, [showMyActionsDropdown,activeTab,searchAuditor]);
  useEffect(() => {
  if (activeUserTab === "coders") {
      dispatch(getCoderFilterOptions({
        search: searchCoders,
        page_number: 1,
        page_size: 10,
      }))
      }

  if (activeUserTab === "auditors") {
    dispatch(getAuditorsFilterOptions({
      search: searchAuditor,
      page_number: 1,
      page_size: 10,
    }))
  }
  }, [activeTab, activeUserTab, searchCoders, searchAuditor])

  // useEffect(() => {
  //   dispatch(
  //     getAuditorsFilterOptions({
  //       search: auditorsFilterOptions.searchAuditor,
  //       page_number: 1,
  //       page_size: 10,
  //     }),
  //   );
  // }, [searchAuditor]);

useEffect(() => {
  if (queues?.length > 0) {
    const checkedQueueIds = queues
      .filter((q) => q.is_checked)
      .map((q) => q.audit_queue_id);

    setSelectedQueueIds(checkedQueueIds);
  }
}, [queues]);



  const handleSelect = (item) => {
    setSelectedVersion(item);
    // Optional: close after selecting
  };

  const handleCheckboxChange = (value) => {
    const isOther = value === "Other (specify)";

    const currentReasons = selectedMissingNotesOptions?.reasons || [];

    const updatedReasons = currentReasons.includes(value)
      ? currentReasons.filter((item) => item !== value)
      : [...currentReasons, value];

    const updatedComments = updatedReasons.map((reason, index) => {
      if (reason === "Other (specify)") {
        const existingIndex = currentReasons.indexOf("Other (specify)");
        return existingIndex !== -1
          ? selectedMissingNotesOptions.additional_comments[existingIndex]
          : "";
      }
      return null;
    });

    dispatch(
      setSelectedMissingNotesOptions({
        reasons: updatedReasons,
        additional_comments: updatedComments,
      }),
    );
  };

  // Safely find the selected DRG data
  const selectedDrgData = drgData?.drgs?.find(
    (obj) => obj[selectedVersion] !== undefined,
  )?.[selectedVersion];
  const isDrgInvalid =
    !selectedDrgData?.drg || selectedDrgData?.drg === "can't determine";

  const handleChange = (event) => {
    setSelectedVersion(event.target.value);
  };

  useEffect(() => {
    if (!selectedVersion || !selectedDrgData) return;

    dispatch(
      storeDrgVersionAndData({
        selectedVersion,
        selectedDrgData,
      }),
    );
  }, [selectedVersion, selectedDrgData]);

  const missingNotesOptions = [
    { label: "Discharge Summary", value: "Discharge Summary" },
    { label: "Operation Report", value: "Operation Report" },
    { label: "Histopathology", value: "Histopathology" },
    { label: "Progress Note()", value: "Progress Note()" },
    { label: "HITH Note()", value: "HITH Note()" },
    { label: "Anaesthetic Chart", value: "Anaesthetic Chart" },
    { label: "Medication Chart", value: "Medication Chart" },
    { label: "Cardiac Cathlab report", value: "Cardiac Cathlab report" },
    { label: "Sleep Study Report", value: "Sleep Study Report" },
    { label: "Incorrect Admission Date", value: "Incorrect Admission Date" },
    { label: "Incorrect Discharge Date", value: "Incorrect Discharge Date" },
    { label: "Other (specify)", value: "Other (specify)" },
  ];
  //   const staticData = [
  //      {
  //     code: "U60Z",
  //     details:[
  //     {
  //       label: "MS-DRG",
  //       drgValue: 885,
  //       DescriptionLabel: "Description",
  //       Descriptionvalue:  "Other Circulatory System Diagnoses with MCC (Major Complications or Comorbidities)",
  //       MDCLabel: "MCD",
  //       MDCValue: "05 – Diseases & Disorders of the Circulatory System",
  //       RelativeWeightLabel: "Relative Weight",
  //       RelativeWeightValue: 0.9524,
  //       EstimatedReimbursementLabel: "Estimated Reimbursement",
  //       EstimatedReimbursementValue: "$5,974"
  //     },
  //   ],
  // },
  // {
  //   code: "960Z",
  //   details: [
  //      {
  //       label: "MS-DRG",
  //       drgValue: 981,
  //       DescriptionLabel: "Description",
  //       Descriptionvalue:  "Gastrointestinal Stromal Tumor (GIST) with Stomach and/or Small Intestine Excision",
  //       MDCLabel: "MCD",
  //       MDCValue: "06 – Diseases & Disorders of the Digestive System",
  //       RelativeWeightLabel: "Relative Weight",
  //       RelativeWeightValue:  9.0,
  //       EstimatedReimbursementLabel: "Estimated Reimbursement",
  //       EstimatedReimbursementValue: "$56,457"
  //      }
  //   ]
  // },
  // {
  //   code: "G48B",
  //   details: [
  //      {
  //       label: "MS-DRG",
  //       drgValue: 603,
  //       DescriptionLabel: "Description",
  //       Descriptionvalue:  "Cellulitis with Major Complications or Comorbidities (MCC)",
  //       MDCLabel: "MCD",
  //       MDCValue: "18 – Infectious and Parasitic Diseases",
  //       RelativeWeightLabel: "Relative Weight",
  //       RelativeWeightValue:  1.6521,
  //       EstimatedReimbursementLabel: "Estimated Reimbursement",
  //       EstimatedReimbursementValue: "$10,346"
  //      }
  //   ]
  // },
  // {
  //   code: "G48A",
  //   details: [
  //      {
  //       label: "MS-DRG",
  //       drgValue: 603,
  //       DescriptionLabel: "Description",
  //       Descriptionvalue:  "Cellulitis with Major Complications or Comorbidities (MCC)",
  //       MDCLabel: "MCD",
  //       MDCValue: "18 – Infectious and Parasitic Diseases",
  //       RelativeWeightLabel: "Relative Weight",
  //       RelativeWeightValue:  1.6521,
  //       EstimatedReimbursementLabel: "Estimated Reimbursement",
  //       EstimatedReimbursementValue: "$10,346"
  //      }
  //   ]
  // },
  // {
  //   code: "Q60B",
  //   details: [
  //      {
  //       label: "MS-DRG",
  //       drgValue: 820,
  //       DescriptionLabel: "Description",
  //       Descriptionvalue:  "Lymphoma and Leukemia with Major Operating Room Procedures with Major Complications or Comorbidities (MCC)",
  //       MDCLabel: "MCD",
  //       MDCValue: "18 – Infectious and Parasitic Diseases",
  //       RelativeWeightLabel: "Relative Weight",
  //       RelativeWeightValue:  4.2122,
  //       EstimatedReimbursementLabel: "Estimated Reimbursement",
  //       EstimatedReimbursementValue: "$26,423"
  //      }
  //   ]
  // },
  // {
  //   code: "I04A",
  //   details: [
  //      {
  //       label: "MS-DRG",
  //       drgValue: 280,
  //       DescriptionLabel: "Description",
  //       Descriptionvalue:  "Acute Myocardial Infarction, Discharged Alive with Major Complications or Comorbidities (MCC)",
  //       MDCLabel: "MCD",
  //       MDCValue: "05 – Diseases & Disorders of the Circulatory System",
  //       RelativeWeightLabel: "Relative Weight",
  //       RelativeWeightValue:  1.2226,
  //       EstimatedReimbursementLabel: "Estimated Reimbursement",
  //       EstimatedReimbursementValue: "$7,669"
  //      }
  //   ]
  // },
  // {
  //   code: "I04B",
  //   details: [
  //      {
  //       label: "MS-DRG",
  //       drgValue: 280,
  //       DescriptionLabel: "Description",
  //       Descriptionvalue:  "Acute Myocardial Infarction, Discharged Alive with Major Complications or Comorbidities (MCC)",
  //       MDCLabel: "MCD",
  //       MDCValue: "05 – Diseases & Disorders of the Circulatory System",
  //       RelativeWeightLabel: "Relative Weight",
  //       RelativeWeightValue:  1.2226,
  //       EstimatedReimbursementLabel: "Estimated Reimbursement",
  //       EstimatedReimbursementValue: "$7,669"
  //      }
  //   ]
  // },
  // {
  //   code: "G64Z",
  //   details: [
  //      {
  //       label: "MS-DRG",
  //       drgValue: 394,
  //       DescriptionLabel: "Description",
  //       Descriptionvalue:  "Other Circulatory System Diagnoses with Major Complications or Comorbidities (MCC)",
  //       MDCLabel: "MCD",
  //       MDCValue: "05 – Diseases & Disorders of the Circulatory System",
  //       RelativeWeightLabel: "Relative Weight",
  //       RelativeWeightValue:  0.9369,
  //       EstimatedReimbursementLabel: "Estimated Reimbursement",
  //       EstimatedReimbursementValue: "$5,877"
  //      }
  //   ]
  // },
  // {
  //   code: "K60B",
  //   details: [
  //      {
  //       label: "MS-DRG",
  //       drgValue: 637,
  //       DescriptionLabel: "Description",
  //       Descriptionvalue:  "Diabetes with Major Complications or Comorbidities (MCC)",
  //       MDCLabel: "MCD",
  //       MDCValue: "10 – Endocrine, Nutritional & Metabolic Diseases & Disorders",
  //       RelativeWeightLabel: "Relative Weight",
  //       RelativeWeightValue:  0.8537,
  //       EstimatedReimbursementLabel: "Estimated Reimbursement",
  //       EstimatedReimbursementValue: "$5,355"
  //      }
  //   ]
  // }
  //   ]
 

  useEffect(() => {
  if (auditors?.length > 0) {

    const selectedAuditor = auditors.find(
      (a) => a.is_checked === true
    );

    if (selectedAuditor) {

      setSelectedAuditorId(selectedAuditor.user_id);

      const queueIds =
        selectedAuditor.audit_queue?.map(
          (q) => q.audit_queue_id
        ) || [];

      setSelectedAuditorQueueIds(queueIds);
    }

  }

}, [auditors]);
  useEffect(() => {
    if (currentScreen === "episodeList") {
      setTotalEpisodes(episodesFilterList?.episode || []);
    } else if (currentScreen === "coderview") {
      setTotalEpisodes(codersData?.episodes || []);
    } else if (currentScreen === "auditorPage") {
      setTotalEpisodes(auditorViewData?.episodes || []);
    }
  }, [currentScreen, episodesFilterList?.episode, codersData, auditorViewData]);
  // const filtered_line_id = totalEpisodes?.map((item) => item?.hcp_line_id);
  // const min_hcp_line_id = Math?.min(...filtered_line_id);
  // const max_hcp_line_id = Math?.max(...filtered_line_id);
  const filtered_line_id = Array?.isArray(totalEpisodes)
    ? totalEpisodes
      ?.map((item) => Number(item?.hcp_line_id))
      ?.filter((id) => !isNaN(id))
    : [];

  const min_hcp_line_id =
    filtered_line_id?.length > 0 ? Math.min(...filtered_line_id) : null;

  const max_hcp_line_id =
    filtered_line_id?.length > 0 ? Math?.max(...filtered_line_id) : null;

  const drgLabels = {
    "960Z": "Ungroupable",
    "961Z": "Unacceptable Principal Diagnosis",
    "963Z": "Neonatal Diagnosis Not Consistent W Age/Weight",
  };
  const checkModalStatus = JSON.parse(
    sessionStorage.getItem("episode-status-modal"),
  );
  const { drgValue, weightValue, reimbursementValue } = useContext(CodeContext);
  const { drgloading } = useContext(CodeContext);

  // const [episodeStatusChangeModal, setEpisodeStatusChangeModal] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const allDrgInformation = useSelector(
    (state) => state?.coder?.drgInformation,
  );
  const allDrgInfoLoading = useSelector(
    (state) => state.coder.loadingDrgInformation,
  );

  const { statusChangeLoading, statusChangeMessage, statusChangeError } =
    useSelector((state) => state.auditorView.status);

  const coderOptions = [
    // {label: "Coding Complete", value: "Coding Complete"},
    { label: "On Hold", value: "On Hold" },
    // { label: "Send to audit", value: "Send to audit" },
    { label: "Outstanding", value: "Outstanding" },
  ];

  const auditorOptions = [
    { label: "Audit - On Hold", value: "Audit - On Hold" },
    { label: "Audited", value: "Audited" },
    // { label: "Audit - Awaiting Audit", value: "Audit - Awaiting Audit" },
    { label: "Audit - Pending CDQ", value: "Audit - Pending CDQ" },
    { label: "Audit in Progress", value: "Audit in Progress" },
  ];

  const { auditorPage } = useSelector((state) => state.auditorView);
  const { auditStatusLoading, auditStatusStateData, auditStatusStateError } =
    useSelector((state) => state.coder.auditStatusState);
  const {
    clusterCodeWarningsIsLoading,
    clusterCodeWarningsWarningList,
    clusterCodeWarningsError,
  } = useSelector((state) => state.coder.clusterCodeWarnings);
  const getDefaultDrg = (data) => {
    const version = data.display_version;
    const match = data?.drgs?.find((d) => d[version]);

    return {
      version,
      drgData: match?.[version] ?? null,
    };
  };

  const { version, drgData: defaultDrgData } = getDefaultDrg(drgData);
  const handleRunDrgAlgorithm = async () => {
    try {
      const allPrincipalCodes = diagnosisStates?.principal?.map(
        (item) => item?.code,
      );
      const allAdditionalCodes = diagnosisStates?.additional?.map(
        (item) => item?.code,
      );
      const allProcedureCodes = diagnosisStates?.procedure?.map(
        (item) => item?.code,
      );

      const hcpLineId = sessionStorage.getItem("last_hcp_line_id");

      const payload = {
        hcp_line_id: hcpLineId,
        drg_code: defaultDrgData?.drg,
        drg_version: version,
        principal_diagnosis_code: allPrincipalCodes.join(","),
        additional_diagnoses_code: allAdditionalCodes,
        procedure_codes: allProcedureCodes,
        weight:
          defaultDrgData.weight === "can't determine"
            ? null
            : defaultDrgData.weight,
        pallas_priority: "INITIAL_REQUEST",
        session_token: null,
        is_confirmed: false,
      };
      const response = await dispatch(triggerPallasAlgoCdc(payload)).unwrap();
      // console.log(response, "szdfxcghjbhgfds");

      if (response?.session_token) {
        sessionStorage.setItem("pallas_session_token", response.session_token);
      }

      dispatch(setIsPallasAlgoApplied(true));
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    if (codingscreendata?.data?.meta) {

      setCurrentEpisode(codingscreendata?.data?.meta);
      setCurrentStatus(codingscreendata?.data?.meta?.status);
    }
    if (
      lastCodedEpisode?.selectedEpisode?.hcp_line_id !== undefined ||
      lastCodedEpisode?.selectedEpisode?.hcp_line_id !== NaN
    ) {
      setCurrentEpisodeNumber(lastCodedEpisode?.selectedEpisode?.hcp_line_id);
    }
  }, [codingscreendata?.data?.meta]);

  // const calculateAge = (dob, admissionDate) => {
  //   if (!dob || !admissionDate) {
  //     return 1;
  //   }

  //   let birthDate, admitDate;

  //   const dobParts = dob.split("-").map(Number);
  //   birthDate =
  //     dobParts[0] > 31
  //       ? new Date(dobParts[0], dobParts[1] - 1, dobParts[2])
  //       : new Date(dobParts[2], dobParts[1] - 1, dobParts[0]);

  //   const admitParts = admissionDate.split("-").map(Number);
  //   admitDate =
  //     admitParts[0] > 31
  //       ? new Date(admitParts[0], admitParts[1] - 1, admitParts[2])
  //       : new Date(admitParts[2], admitParts[1] - 1, admitParts[0]);

  //   let age = admitDate.getFullYear() - birthDate.getFullYear();
  //   const monthDiff = admitDate.getMonth() - birthDate.getMonth();

  //   if (
  //     monthDiff < 0 ||
  //     (monthDiff === 0 && admitDate.getDate() < birthDate.getDate())
  //   ) {
  //     age--;
  //   }

  //   if (age === 0) {
  //     return 1;
  //   }

  //   return isNaN(age) ? 1 : age;
  // };

  // const age = calculateAge(
  //   currentEpisode?.date_of_birth,
  //   currentEpisode?.admission_date,
  // );

  function getEpisodeData(currentEpisode, useLabelFallback = false) {
    function displayValue(value, label) {
      if (value === null || value === undefined || value === "") {
        return useLabelFallback ? `No ${label.toLowerCase()}` : "-";
      }
      if (
        currentEpisode?.episode_identifier === "2COLONOSCOPY" &&
        (label === "Admission Date" || label === "Discharge Date")
      ) {
        return new Date("2025-07-24").toISOString().split("T")[0];
      } else {
        return value;
      }
    }

    return [
      {
        label: "MRN",
        value: displayValue(currentEpisode?.medical_record_number, "MRN"),
      },
      {
        label: "Episode ID",
        value: displayValue(currentEpisode?.episode_identifier, "Episode ID"),
      },
      {
        label: "Admission Date",
        value: displayValue(currentEpisode?.admission_date, "Admission Date"),
      },
      {
        label: "Discharge Date",
        value: displayValue(currentEpisode?.separation_date, "Discharge Date"),
      },
      { label: "Age", value: displayValue(currentEpisode?.age_y, "Age") },
      { label: "Sex", value: displayValue(currentEpisode?.sex, "Sex") },
      {
        label: "Length of stay",
        value:
          currentEpisode?.episode_identifier === "2COLONOSCOPY"
            ? 1
            : (currentEpisode?.los ?? 0),
      },
      {
        label: "Speciality",
        value: displayValue(currentEpisode?.speciality, "Speciality"),
      },
      {
        label: "Status",
        value: displayValue(statusText, "Status"),
      },
    ];
  }

  const episodeDataWithDash = getEpisodeData(currentEpisode, false);
  const episodeDataWithLabel = getEpisodeData(currentEpisode, true);

  const changeRecord = (id, newData) => {
    let newEpisode =
      newData?.length > 0 && newData?.find((eId) => eId?.hcp_line_id === id);
    setCurrentEpisode(newEpisode);
    dispatch(selectedEpisodeList(newEpisode));
    dispatch(
      setEpisodeIdentifierTopassDocumentViewer(newEpisode?.episode_identifier),
    );
  };

  const unlockEpisodeOnce = () => {
    const lockedId = sessionStorage.getItem("locked_prev_hcp_line_id");

    dispatch(getunlockEpisode({ hcp_line_id: String(lockedId) })).catch(
      (err) => {
        console.error(" Unlock failed", err);
      },
    );
  };
  const callRemoveCode = async () => {
    const hcpLineId = sessionStorage.getItem("last_hcp_line_id");
    const alreadyConfirmed = sessionStorage.getItem("isConfirmed") === "true";

    if (!hcpLineId) return;

    if (
      (!JSON.parse(sessionStorage.getItem("initialprincipalDiagnosisState")) &&
        !JSON.parse(
          sessionStorage.getItem("initialadditionalDiagnosisState"),
        ) &&
        !JSON.parse(
          sessionStorage.getItem("initialprocedureDiagnosisState"),
        )) ||
      alreadyConfirmed
    ) {
      return;
    }

    try {
      await removeCode({
        hcp_line_id: hcpLineId,
        principal_diagnosis_code:
          JSON.parse(
            sessionStorage.getItem("initialprincipalDiagnosisState"),
          ) || [],
        additional_diagnosis_codes:
          JSON.parse(
            sessionStorage.getItem("initialadditionalDiagnosisState"),
          ) || [],
        procedure_codes:
          JSON.parse(
            sessionStorage.getItem("initialprocedureDiagnosisState"),
          ) || [],
      });

      sessionStorage.removeItem("initialprincipalDiagnosisState");
      sessionStorage.removeItem("initialadditionalDiagnosisState");
      sessionStorage.removeItem("initialprocedureDiagnosisState");
    } catch (error) {
      console.error("Remove code API failed:", error);
    }
  };
   // ✅ SHARED HELPER: fetch available queues for a given hcp_line_id and handle modal
   const fetchAndSetAvailableQueues = (hcpLineId) => {
  // ✅ Clear immediately before fetching so stale data never leaks
  dispatch(setClickedEpisodeQueues([]));
  dispatch(setSelectedQueue(null));
  sessionStorage.removeItem("line_assignment_id"); // ← clear this too

  const payload = {
    hcp_line_id: hcpLineId,
    screen_type: currentScreen === "auditorPage" ? "auditor" : currentScreen === "coderview" ? "coder" : "coder",
  };

  dispatch(showAvailableAuditQueues(payload)).then((res) => {
    if (res?.payload) {
      const allQueues = [
        ...(res.payload.queues || []),
        ...(res.payload.queues_user || []),
      ];

      // ✅ Only set if new episode actually has queues
      if (allQueues.length > 0) {
        dispatch(setClickedEpisodeQueues(allQueues));
        dispatch(setSelectedQueue(allQueues.length === 1 ? allQueues[0] : null));
      } else {
        // ✅ New episode has no queues — keep it empty
        dispatch(setClickedEpisodeQueues([]));
        dispatch(setSelectedQueue(null));
      }

      setTimeout(() => {
        setShowAuditQueueModal(allQueues.length > 1);
        setIsLoadingQueues(false);
      }, 100);
    } else {
      // ✅ API returned nothing — clear everything
      dispatch(setClickedEpisodeQueues([]));
      dispatch(setSelectedQueue(null));
      setIsLoadingQueues(false);
    }
  });
};

  const handleDocumentPrev = () => {
    setIsLoadingQueues(true);
    setNewlyInsertedCodes([]);
    setDeletedCodes([]);
    dispatch(setSelectedQueue(null));
    resetQueueFromNavigation();
    // resetQueueFromNavigationAudit()
    setShowAuditQueueModal(false);
    dispatch(setClickedEpisodeQueues([])); 
    sessionStorage.setItem("trackHistory", JSON.stringify([]));
    sessionStorage.setItem("redoStack", JSON.stringify([]));
    handleEpisodeChange();
    setSkipAcceptApi(true);
    dispatch(setDocumentviewerPage(1));
    dispatch(resetEpisodeIdentifierTopassDocumentViewer());
    callRemoveCode();
    setCurrentEpisodeNumber((prev) => {
      const allHcpData = totalEpisodes?.map((item) => item?.hcp_line_id) || [];
      const currentIndex = allHcpData?.indexOf(prev);
      const isFirstItem = currentIndex === 0;
      sessionStorage.setItem("locked_prev_hcp_line_id", prev);

      let hasPrevPage = false;
      if (currentScreen === "episodeList") {
        hasPrevPage = newEpisodeListFilterObj.page > 1;
      } else if (currentScreen === "coderview") {
        hasPrevPage = newEpisodeListFilterObj?.page_number > 1;
      } else if (currentScreen === "auditorPage") {
        hasPrevPage = newEpisodeListFilterObj?.page_number > 1;
      }

      let updatedFilter = { ...newEpisodeListFilterObj };
      if (isFirstItem && hasPrevPage) {
        if (currentScreen === "episodeList") {
          updatedFilter.page -= 1;
        } else {
          updatedFilter.page_number -= 1;
        }
        sessionStorage.setItem("filters", JSON.stringify(updatedFilter));
      } else {
        updatedFilter =
          JSON.parse(sessionStorage.getItem("filters")) || updatedFilter;
      }

      const fetchDataAndUpdate = async () => {
        try {
          let response;
          let newData = [];

          switch (currentScreen) {
            case "episodeList":
              response = await dispatch(
                getFilterEpisodeLists(updatedFilter),
              ).unwrap();
              newData = response?.episode || [];
              const currentIndex = Number(currentEpisodeIndex) || 0;
              const decrementCurrentEpisodeIndex =
                currentIndex - 1 >= 0 ? currentIndex - 1 : 0;
              sessionStorage.setItem(
                "currentEpisodeIndex",
                decrementCurrentEpisodeIndex,
              );
              break;
            case "coderview":
              response = await dispatch(
                fetchCodersData(updatedFilter),
              ).unwrap();
              newData = response?.episodes || [];
              break;

            case "auditorPage":
              response = await dispatch(
                getAuditorViewData(updatedFilter),
              ).unwrap();
              newData = response?.episodes || [];
              break;
          }

          if (newData?.length > 0) {
            setTotalEpisodes(newData);
            const updatedHcpLineIds = newData.map((item) => item.hcp_line_id);

            const prevId = isFirstItem
              ? updatedHcpLineIds[updatedHcpLineIds.length - 1]
              : allHcpData[currentIndex - 1];

            if (prevId) {
              changeRecord(prevId, newData);
              sessionStorage.setItem("last_hcp_line_id", prevId);
              triggerGetData2();
                // ✅ NEW: fetch available queues for prev episode (same as CoderView)
              fetchAndSetAvailableQueues(prevId);
              return prevId;
            }
          }
        } catch (err) {
          console.error("Fetch failed:", err);
        }
      };

      fetchDataAndUpdate();

      return prev;
    });
  };

  const handleDocumentNext = () => {
    setIsLoadingQueues(true);
    dispatch(setSelectedQueue(null));
    setNewlyInsertedCodes([]);
    setDeletedCodes([]);
    resetQueueFromNavigation();
    // resetQueueFromNavigationAudit()
    setShowAuditQueueModal(false);
     dispatch(setClickedEpisodeQueues([]));
    sessionStorage.setItem("trackHistory", JSON.stringify([]));
    sessionStorage.setItem("redoStack", JSON.stringify([]));
    handleEpisodeChange();
    setSkipAcceptApi(true);
    dispatch(setDocumentviewerPage(1));
    dispatch(resetEpisodeIdentifierTopassDocumentViewer());
    callRemoveCode();
    setCurrentEpisodeNumber((prev) => {
      const allHcpData = totalEpisodes?.map((item) => item?.hcp_line_id) || [];
      const currentIndex = allHcpData?.indexOf(prev);
      const isLastItem = currentIndex === allHcpData?.length - 1;
      sessionStorage.setItem("locked_prev_hcp_line_id", prev);

      // console.log(prev, "jyoti");
      let hasNextPage = false;
      if (currentScreen === "episodeList") {
        hasNextPage =
          newEpisodeListFilterObj.page <
          Math.ceil(
            episodesFilterList?.total_episodes /
            newEpisodeListFilterObj.page_size,
          );
      } else if (currentScreen === "coderview") {
        hasNextPage =
          newEpisodeListFilterObj?.page_number <
          Math.ceil(codersData?.episode_meta_data?.total_count / 10);
      } else if (currentScreen === "auditorPage") {
        hasNextPage =
          newEpisodeListFilterObj?.page_number <
          Math.ceil(auditorViewData?.episode_meta_data?.meta?.total_count / 10);
      }

      // 🟢 prepare updated filter (for both cases)
      let updatedFilter = { ...newEpisodeListFilterObj };
      if (isLastItem && hasNextPage) {
        if (currentScreen === "episodeList") {
          updatedFilter.page += 1;
        } else {
          updatedFilter.page_number += 1;
        }
        sessionStorage.setItem("filters", JSON.stringify(updatedFilter));
      } else {
        // use same filter if not last
        updatedFilter =
          JSON.parse(sessionStorage.getItem("filters")) || updatedFilter;
      }

      // 🟢 single fetch function (for both cases)
      const fetchDataAndUpdate = async () => {
        try {
          let response;
          let newData = [];

          switch (currentScreen) {
            case "episodeList":
              response = await dispatch(
                getFilterEpisodeLists(updatedFilter),
              ).unwrap();
              newData = response?.episode || [];
              const totalEpisodes = newData.length;
              const currentIndex = Number(currentEpisodeIndex) || 0;
              const incrementCurrentEpisodeIndex =
                currentIndex + 1 < totalEpisodes
                  ? currentIndex + 1
                  : currentIndex;
              sessionStorage.setItem(
                "currentEpisodeIndex",
                incrementCurrentEpisodeIndex,
              );
              break;

            case "coderview":
              response = await dispatch(
                fetchCodersData(updatedFilter),
              ).unwrap();
              newData = response?.episodes || [];
              break;

            case "auditorPage":
              response = await dispatch(
                getAuditorViewData(updatedFilter),
              ).unwrap();
              newData = response?.episodes || [];
              break;
          }

          if (newData?.length > 0) {
            setTotalEpisodes(newData);
            const updatedHcpLineIds = newData.map((item) => item.hcp_line_id);
            const nextId = isLastItem
              ? updatedHcpLineIds[0] // next page’s first item
              : allHcpData[currentIndex + 1]; // same page next item

            if (nextId) {
              changeRecord(nextId, newData);
              sessionStorage.setItem("last_hcp_line_id", nextId);
              triggerGetData2();
                   // ✅ NEW: fetch available queues for next episode (same as CoderView)
              fetchAndSetAvailableQueues(nextId);
              return nextId;
            }
          }
        } catch (err) {
          console.error("❌ Fetch failed:", err);
        }
      };

      fetchDataAndUpdate();
      return prev;
    });
  };
  // ✅ Auto-select queue based on loginUserID when modal opens
useEffect(() => {
  if (!showAuditQueueModal || clickedEpisodeQueues.length === 0) return;

  // Priority 1: assigned to login user with no review reason (direct assignment)
  const assignedToMe = clickedEpisodeQueues.find(
    (q) => q.assigned_user_id === loginUserID && !q.assignment_reason?.trim()
  );

  // Priority 2: for review assigned to login user
  const forReviewToMe = clickedEpisodeQueues.find(
    (q) => q.assigned_user_id === loginUserID && q.assignment_reason?.trim()
  );

  // Priority 3: first available normal queue
  const firstAvailable = clickedEpisodeQueues.find(
    (q) => !("assigned_user_id" in q)
  );

  // Priority 4: just first item
  const fallback = clickedEpisodeQueues[0];

  const queueToAutoSelect = assignedToMe || forReviewToMe || firstAvailable || fallback;

  if (queueToAutoSelect) {
    handleQueueSelect(queueToAutoSelect);
  }
}, [showAuditQueueModal, clickedEpisodeQueues]);

  // Always set default version to "11" when data is available
  useEffect(() => {
    if (!drgData?.grouper_versions?.length) return;

    if (process.env.REACT_APP_FLAG_USA) {
      setSelectedVersion("42.1");
    } else {
      setSelectedVersion(drgData.grouper_versions[0]);
    }
  }, [drgData]);

  const isCodeAssist =
    location.pathname.includes("Code-Assist") ||
    location.pathname.includes("Auditor-CodeAssist-Screen");
const handleHopistalPasView = async (
  last_hcp_line_id
) => {
  try {
    setIsPasLoading(true);

    const res = await viewEmrDmrPas(
      last_hcp_line_id
    );

    const launchUrl =
      res?.data?.launch_url;

    if (!launchUrl) {
      toast.error("Launch URL missing");
      return;
    }

    // Launch Electron protocol
    window.location.href = launchUrl;

    toast.success("Opening in Sancare...");
  } catch (err) {
    console.error(err);

    toast.error(
      "Failed to open Sancare."
    );
  } finally {
    setIsPasLoading(false);
  }
};
  // console.log(pasHyperLink, "checkhyp");
  const handleHyperLinkMouseLeave = () => {
    setShowTooltipHover(false);
  };
  useEffect(() => {
    dispatch(getHealthFundContractFilterOptions());
  }, []);

  useEffect(() => {
    const newData = {
      ...episodeDetailsFromStorage,
      status: currentStatus,
    };
    sessionStorage.setItem("episodeDetails", JSON.stringify(newData));
  }, [currentStatus]);

  const customStyles = {
    control: (provided) => ({
      ...provided,
      maxHeight: "60px",
      overflowY: "auto",
      width: "100%",
      fontSize: "12px",
      backgroundColor: "#c2e7ff",
      border: "none",
      outline: "none",
      fontWeight: "bold",
    }),

    singleValue: (provided) => ({
      ...provided,
      color: "#344054",
      textAlign: "center",
    }),

    option: (provided, state) => ({
      ...provided,
      fontSize: "12px",
      backgroundColor: state.isFocused ? "#f0f0f0" : "white",
      color: "black",
      cursor: "pointer",
      width: "100%",
    }),

    menu: (provided) => ({
      ...provided,
      width: "100%",
    }),

    menuList: (provided) => ({
      ...provided,
      width: "100%",
    }),

    dropdownIndicator: (provided) => ({
      ...provided,
      padding: "0",
    }),

    multiValueRemove: (provided) => ({
      ...provided,
      display: "none",
    }),
  };

  // console.log(episodeList,'selectedEpisode');

  const handleStatusChange = (item) => {
    const statusValue = item?.value?.trim();
    const isCoderView = currentScreen === "coderview";
    const isAuditorPage = currentScreen === "auditorPage";

    const payload = {
      hcp_line_id: currentEpisode?.hcp_line_id,
      status:
        statusValue ||
        currentEpisode?.status?.map((item) => item.status)?.trim(),
      auditorPage: isAuditorPage ? true : false,
    };
    dispatch(changeStatus(payload))
      .unwrap()
      ?.then((res) => {
        // if(isAuditorPage){
        // dispatch(updateAuditorPage(true));
        // }else{
        // dispatch(updateAuditorPage(false));
        // }
        toast.success("Status updated successfully");
        if (isCoderView && statusValue === "Send to audit") {
          sessionStorage.setItem("episode-status-modal", "true");
          setOpenStatusUpdatedModal(true);
          setCurrentStatus(statusValue);
        } else if (isAuditorPage && statusValue === "Audited") {
          sessionStorage.setItem("episode-status-modal", "true");
          setOpenStatusUpdatedModal(true);
          setCurrentStatus(statusValue);
        } else {
          sessionStorage.setItem("episode-status-modal", "false");
          setOpenStatusUpdatedModal(false);
          setCurrentStatus(statusValue);
          // window.location.reload();
        }
      })
      .catch((err) => {
        console.error("Status update error:", err);
        toast.error(err?.message || "Status update failed. Please try again.");
      });
  };
  const handleQueueToggle = (queueId, checked) => {
    setSelectedQueueIds((prev) =>
      checked ? [...prev, queueId] : prev.filter((id) => id !== queueId),
    );
  };

  const handleAuditorQueueToggle = (queueId, checked) => {
    setSelectedAuditorQueueIds((prev) =>
      checked ? [...prev, queueId] : prev.filter((id) => id !== queueId),
    );
  };
  const handleQueueSelect = (queue) => {
      // console.log(queue,'fffffff')
        if (queue?.line_assignment_id) {
    sessionStorage.setItem("line_assignment_id", String(queue.line_assignment_id));
  } else {
    sessionStorage.removeItem("line_assignment_id");
  }

    dispatch(setSelectedQueue(queue));
    // setShowAuditQueueModal(false)
  };

  const handleAuditQueueCloseIcon = (e) => {
    e.stopPropagation(); // safety
    if (!selectedQueueworkSpace?.queue_id) {
      // toast.warning("Please select a queue before proceeding");
      // return;
    }
    setShowAuditQueueModal(false); 
  };

  // useEffect(() => {
  //   if (selectedQueueworkSpace?.length === 1) {
  //     dispatch(setSelectedQueue(selectedQueueworkSpace[0])); // ✅ auto select
  //     setShowAuditQueueModal(false); // ✅ no modal
  //   }
  // }, [selectedQueueworkSpace, dispatch]);

  // console.log(allOriginsAreU, allCodes, isButtonEnabled, "usercodes");

  const disablePrev = () => {
    if (currentScreen === "episodeList") {
      return (
        (newEpisodeListFilterObj.page === 1 &&
          currentEpisodeNumber === min_hcp_line_id) ||
        currentEpisode === undefined ||
        waitTillLoad
      );
    } else if (currentScreen === "coderview") {
      return (
        (newEpisodeListFilterObj?.page_number === 1 &&
          currentEpisodeNumber === min_hcp_line_id) ||
        currentEpisode === undefined ||
        waitTillLoad
      );
    } else if (currentScreen === "auditorPage") {
      return (
        (newEpisodeListFilterObj?.page_number === 1 &&
          currentEpisodeNumber === min_hcp_line_id) ||
        currentEpisode === undefined ||
        waitTillLoad
      );
    }
  };

  const disableNext = () => {
    if (currentScreen === "episodeList") {
      return (
        (currentEpisodeNumber === max_hcp_line_id &&
          newEpisodeListFilterObj.page ===
          (newEpisodeListFilterObj.page_size > 0
            ? Math.ceil(
              episodesFilterList?.total_episodes /
              newEpisodeListFilterObj.page_size,
            )
            : 0)) ||
        currentEpisode === undefined ||
        waitTillLoad
      );
    } else if (currentScreen === "coderview") {
      return (
        (currentEpisodeNumber === max_hcp_line_id &&
          newEpisodeListFilterObj?.page_number ===
          (10 > 0
            ? Math.ceil(codersData?.episode_meta_data?.total_count / 10)
            : 0)) ||
        currentEpisode === undefined ||
        waitTillLoad
      );
    } else if (currentScreen === "auditorPage") {
      return (
        (currentEpisodeNumber === max_hcp_line_id &&
          newEpisodeListFilterObj?.page_number ===
          (10 > 0
            ? Math.ceil(
              auditorViewData?.episode_meta_data?.meta?.total_count / 10,
            )
            : 0)) ||
        currentEpisode === undefined ||
        waitTillLoad
      );
    }
  };

  const drawerContent = (
    <Box p={2} sx={{ backgroundColor: "c2e7ff", height: "100%" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: { md: "space-evenly" },
          alignItems: "center",
          marginBottom: "10px",
        }}
      >
        <Typography variant="h6" gutterBottom sx={{ margin: "0px" }}>
          Episode Details
        </Typography>
        {!isCodeAssist && (
          <Pagination size="" className="episodestatus-pagination">
            <Pagination.Prev
              onClick={() => {
                unlockEpisodeOnce();
                handleDocumentPrev;
              }}
              disabled={disablePrev()}
              className="prev-episode"
            />
            <Pagination.Next
              onClick={() => {
                unlockEpisodeOnce();
                handleDocumentNext;
              }}
              disabled={disableNext()}
              className="next-episode"
            />
          </Pagination>
        )}
      </Box>
      <Box
        sx={{
          width: "100%",
          display: "grid",
          gridTemplateColumns:
            "repeat(auto-fill, minmax(min(200px, 100%), 1fr))",
          gap: 2,
        }}
      >
        {episodeDataWithLabel?.map((item, index) => (
          <Card>
            <CardActionArea
              sx={{
                height: "100%",
                "&[data-active]": {
                  backgroundColor: "action.selected",
                  "&:hover": {
                    backgroundColor: "action.selectedHover",
                  },
                },
              }}
            >
              <CardContent sx={{ height: "100%" }}>
                <Typography component="div" color="text.secondary">
                  {item?.label}
                </Typography>
                <Typography variant="body2" color="text.black">
                  {item?.value}
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        ))}
      </Box>
    </Box>
  );

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const isCodingDataEmpty = (codingData) => {
    const { principal, additional, procedure } = codingData || {};

    const isPrincipalEmpty =
      !Array.isArray(principal) ||
      principal.length === 0 ||
      principal.every((item) => !item?.code);

    const isAdditionalEmpty =
      !Array.isArray(additional) ||
      additional.length === 0 ||
      additional.every((item) => !item?.code);

    const isProcedureEmpty =
      !Array.isArray(procedure) ||
      procedure.length === 0 ||
      procedure.every((item) => !item?.code);

    return isPrincipalEmpty && isAdditionalEmpty && isProcedureEmpty;
  };

  const isEmpty = isCodingDataEmpty(diagnosisStates);
  const canSendForReview = () => {
    const currentStatuses = codingscreendata?.data?.meta?.status || [];
    const allowedStatuses = ["Coding Complete", "Audited", "Awaiting Audit"];
    return currentStatuses.some((status) =>
      allowedStatuses.includes(status.status),
    );
  };
  // console.log(isEmpty, diagnosisStates, "selectedDrgData");

  const TableRow = ({ label, value }) => (
    <tr>
      <td
        style={{
          padding: "8px",
          fontWeight: "bold",
          fontSize: "13px",
          color: "#555",
          width: "50%",
          textAlign: "center",
          // border: "1px solid #dddddd"
        }}
      >
        {label}
      </td>
      <td
        style={{
          padding: "8px",
          fontSize: "13px",
          color: "#333",
          textAlign: "center",
          fontWeight: "bold",
          // border: "1px solid #dddddd"
        }}
      >
        {value || "No value"}
      </td>
    </tr>
  );
  useEffect(() => {
    return () => {
      toast.dismiss();
    };
  }, []);

  useEffect(() => {
    setSearchCoders("");
    setSearchAuditor("");
    setSearchQueues("");
    setSearchAuditorQueues("");
  }, [activeUserTab, activeTab]);

  return (
    <Container fluid className="episode-container">
      <>
        {/* Row 1: Dynamic Episode Details */}
        {isLargeScreen && (
          <>
            <Grid
              container
              columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
              spacing={1}
              sx={{
                display: "flex",
                width: "100%",
                flexWrap: "wrap",
                mt: { lg: 5, md: 2, sm: 2, xs: 1 },
                justifyContent: "space-between",
              }}
            >
              <Grid item xs={12} sm={6} md={6}>
                <Drawer
                  anchor="right"
                  variant={isLargeScreen ? "temporary" : "permanent"}
                  open={isLargeScreen ? mobileOpen : true}
                  onClose={handleDrawerToggle}
                  ModalProps={{ keepMounted: true }}
                  sx={{
                    "& .MuiDrawer-paper": {
                      boxSizing: "border-box",
                      width: {
                        lg: "30%",
                        md: "50%",
                        sm: "70%",
                        xs: "80%",
                      },
                    },
                  }}
                >
                  {drawerContent}
                </Drawer>
              </Grid>
            </Grid>
          </>
        )}
        {!isLargeScreen && (
          <Row className="d-flex  flex-wrap">
            {/* {statusChangeMessage?.length > 0 && (
              <ToastContainer position="top-right" autoClose={3000} />
            )} */}
            <div
              className="d-flex flex-wrap align-items-center"
              style={{ gap: "5px" }}
            >
              <div className="d-flex align-items-center">
                <Typography
                  className="episode-header"
                  sx={{
                    padding: isCodeAssist ? "16px" : "0",
                    fontSize: {
                      lg: "16px",
                      md: "13px",
                      xs: "10px",
                    },
                  }}
                >
                  {" "}
                  {isCodeAssist ? "Code Assist" : "Episode Details"}
                </Typography>
                {!isCodeAssist && (
                  <Pagination size="" className="episodestatus-pagination">
                    <Pagination.Prev
                      onClick={handleDocumentPrev}
                      disabled={disablePrev()}
                      className="prev-episode"
                    />
                    <Pagination.Next
                      onClick={handleDocumentNext}
                      disabled={disableNext()}
                      className="next-episode"
                    />
                  </Pagination>
                )}
              </div>
              <Box
                className="d-flex flex-wrap"
                sx={{ gap: "5px", display: "flex" }}
              >
                {episodeDataWithDash?.map((item, index) => {
                  const labelKey = item.label?.trim();
                  const sliceLength = SLICE_CONFIG[labelKey];
                  const value = item.value || "-";
                  const shouldSlice = sliceLength && value.length > sliceLength;
                  const isStatus = item.label === "Status";
                  return (
                    <Typography
                      component="span"
                      key={index}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        fontSize: {
                          lg: "13px",
                          md: "12px",
                          xs: "11px",
                        },
                        color: "#6e7c87",
                      }}
                    >
                      {item.label}:
                      {/* {isStatus && (
        <Tooltip title={value}>
          <Typography
            sx={{
              marginLeft: "4px",
              maxWidth: "150px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              fontSize: "13px",
              cursor: "pointer",
            }}
          >
            {value[0]}
          </Typography>
        </Tooltip>
      )} */}
                      <Typography
                        className="info-value"
                        sx={{
                          marginLeft: "4px",
                          fontSize: {
                            lg: "13px",
                            md: "12px",
                            xs: "11px",
                          },
                        }}
                      >
                        {isStatus && isStatusUpdated ? (
                          // 🔹 ONLY STATUS SHOWS LOADER
                          <p
                            style={{
                              color: "#ed6c02", // medical-style info color
                              fontStyle: "italic",
                              fontSize: "13px",
                              marginBottom: "0px",
                              fontWeight: "bold",
                            }}
                          >
                            Checking for status updates...
                          </p>
                        ) : // or: <CircularProgress size={14} />
                          shouldSlice ? (
                            // 🔹 SLICED VALUE (for all non-loading cases)
                            <Tooltip title={item?.value}>
                              <Typography
                                className="info-value"
                                sx={{
                                  fontSize: {
                                    lg: "13px",
                                    md: "12px",
                                    xs: "11px",
                                  },
                                }}
                              >
                                {item?.value?.slice(0, sliceLength)}...
                              </Typography>
                            </Tooltip>
                          ) : (
                            // 🔹 NORMAL VALUE
                            item?.value
                          )}
                      </Typography>
                    </Typography>
                  );
                })}
              </Box>
            </div>
          </Row>
        )}

        <Grid
          spacing={1}
          columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
          sx={{
            width: "100%",
            display: {
              xs: "block",
              md: "block",
              lg: "flex",
            },
            mt: { sm: 1, xs: 1 },
            justifyContent: "space-between",
            alignItems: {
              lg: "center",
              md: "center",
              xs: "center",
            },
            marginTop: {
              lg: "-0.9rem !important",
              md: "15px",
              sm: "15px",
            },
            flexWrap: {
              lg: "wrap",
            },
          }}
        >
          <Grid
            sx={{
              display: {
                lg: "flex",
                md: "flex",
                sm: "flex",
                xs: "block",
              },
              mt: typeOfPatient !== "outPatient" ? 0 : 4,

              justifyContent: {
                lg: "start",
                md: "start",
                sm: "start",
                xs: "space-between",
              },
              height: {
                lg: "0px",
                // md: ",
                // lg: "0px",
                // lg: "0px",
              },
              alignItems: "center",
            }}
            className="status-wrapper"
          >
            {/* Episode details button for large screen */}

            <Grid
              item
              sx={{
                width: {
                  xs: "100%",
                  sm: "50%",
                  md: "auto",
                  lg: "auto",
                },
                display: {
                  lg: "flex",
                  md: "flex",
                  sm: "block",
                  xs: "flex",
                },
                justifyContent: {
                  lg: "space-between",
                  md: "space-between",
                  sm: "space-between",
                  xs: "space-between",
                },
                alignItems: "center",
              }}
              className="status-wrapper-div"
            >
              {isLargeScreen && !isSmallScreen && (
                <Grid
                  sx={{
                    mr: { lg: 1, md: 0, sm: 0, xs: 2 },
                    ml: { lg: 0, md: 0, sm: 0, xs: 0 },
                  }}
                >
                  <Button
                    variant="outline-secondary"
                    onClick={handleOpen}
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    size="sm"
                    className="view-button"
                  >
                    {isCodeAssist ? (
                      <Typography sx={{ fontSize: "14px", fontWeight: 600 }}>
                        Code Assist
                      </Typography>
                    ) : (
                      <Typography sx={{ fontSize: "14px", fontWeight: 600 }}>
                        Episode Details
                      </Typography>
                    )}
                    <ArrowDropDownIcon />
                  </Button>
                </Grid>
              )}
              {/* Episode details button for small screen */}

              {isSmallScreen && (
                <Grid
                  sx={{
                    mt: { sm: 0 },
                    mr: { sm: 1, sx: 1 },
                    mb: { sm: 1, xs: 0 },
                    ml: { sm: 0 },
                    p: {
                      sm: 2,
                    },
                    fontWeight: "600",
                  }}
                  className="view-epdetails-div"
                >
                  <Button
                    variant="outline-secondary"
                    onClick={handleOpen}
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "100%",
                    }}
                    size="sm"
                    className="view-button"
                  >
                    {isCodeAssist ? (
                      <Typography sx={{ fontSize: "12px" }}>
                        Code Assist
                      </Typography>
                    ) : (
                      <Typography sx={{ fontSize: "12px" }}>
                        Episode Details
                      </Typography>
                    )}
                    <ArrowDropDownIcon />
                  </Button>
                </Grid>
              )}
              <Grid
                sx={{
                  mt: { lg: 0, md: 0, sm: 1 },
                  mb: { lg: 0 },
                  ml: { lg: 0, md: 1, sm: 0 },
                  mr: { lg: 1, md: 1 },
                }}
                className="view-emr-div"
              >
                <div
                  style={{ display: "inline-block", position: "relative" }}
                  tabIndex={0}
                  className="view-smr-btn"
                >
                  <Tooltip
                    open={showTooltipHover}
                    onClose={() => setShowTooltipHover(false)}
                    title={
                      <div style={{ pointerEvents: "auto" }}>
                        {pasHyperLink ? (
                          <a
                            href={pasHyperLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              color: "#fff",
                              textDecoration: "underline",
                              fontSize: "12px",
                            }}
                            onClick={(e) => e.stopPropagation()}
                          >
                            Open PAS Link
                          </a>
                        ) : (
                          "Loading..."
                        )}
                      </div>
                    }
                    placement="top"
                    arrow
                    disableInteractive={false}
                  >
                    <Button
                      onBlur={() =>
                        setTimeout(() => setShowTooltipHover(false), 200)
                      }
                      className="view-button"
                      disabled={islockedKeyforepisode}
                      onClick={(e) => {
                        e.preventDefault();
                        handleHopistalPasView(last_hcp_line_id);
                      }}
                    >
                      {isSmallScreen ? (
                        <Typography
                          sx={{ fontSize: "12px", textAlign: "center" }}
                        >
                          {isPasLoading ? "Loading..." : "View EMR/SMR/DMR"}
                        </Typography>
                      ) : (
                        <span>
                          {isPasLoading ? "Loading..." : "View EMR/SMR/DMR"}
                        </span>
                      )}
                      {/* View EMR/SMR/DMR */}
                    </Button>
                  </Tooltip>
                </div>
              </Grid>
            </Grid>

            <Grid
              item
              sx={{
                width: {
                  xs: "100%",
                  sm: "50%",
                  md: "auto",
                  lg: "auto",
                },
                display: {
                  lg: "contents",
                  md: "flex",
                  sm: "block",
                  xs: "flex",
                },
                alignItems: "center",
                justifyContent: {
                  lg: "end",
                  md: "end",
                  sm: "end",
                  xs: "space-between",
                },
                flexWrap: {
                  sm: "wrap",
                  xs: "wrap",
                },
              }}
              className="status-wrapper-div"
            >
              <Grid
                sx={{
                  mt: { lg: 0, sm: 0, xs: 1 },
                  mb: { lg: 0, md: 0, sm: 1 },
                  ml: { lg: 1, md: 0, sm: 0, xs: 0 },
                  mr: { lg: 1, md: 1 },
                }}
                className="my-actions-div"
              >
                <Dropdown
                  autoClose="outside"
                  show={showMyActionsDropdown}
                  onToggle={(isOpen) => setShowMyActionsDropdown(isOpen)}
                >
                  <Dropdown.Toggle
                    variant="light"
                    className="status-change-dropdown-btn"
                    disabled={islockedKeyforepisode || isDrgInvalid}
                  >
                    <Tooltip title={"My Actions"}>
                      {isSmallScreen ? (
                        <Typography
                          sx={{ fontSize: "12px", textAlign: "center" }}
                        >
                          My Actions
                        </Typography>
                      ) : (
                        "My Actions"
                      )}
                      {/* My Actions */}
                    </Tooltip>
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="my-actions-dropdown">
                    <Dropdown.Item
                      style={{ width: "100%" }}
                      onClick={() => {
                        setAuditStatusChangeModal(true);
                        dispatch(
                          getAuditResponse({
                            hcp_line_id: currentEpisode?.hcp_line_id
                              ? currentEpisode?.hcp_line_id
                              : last_hcp_line_id
                                ? last_hcp_line_id
                                : "",
                            episode_identifier:
                              currentEpisode?.episode_identifier
                                ? currentEpisode?.episode_identifier
                                : last_epi_identifier
                                  ? last_epi_identifier
                                  : "",
                          }),
                        );
                      }}
                    >
                      <BiBarChartSquare
                        size={20}
                        color="#0d6efd"
                        className="me-2"
                      />
                      View audit log
                    </Dropdown.Item>
                    {/* <Tooltip
                      title={
                        disableOnHold
                          ? "No codes available for awaiting CDQ response"
                          : ""
                      }
                      arrow
                      disableHoverListener={!disableOnHold}
                    > */}
                      <span>
                        <Dropdown.Item
                          onClick={() => handleSendToAudit("awaitingCDQ")}
                          // disabled={disableOnHold}
                          style={{ opacity: disableOnHold ? 0.5 : 1 }}
                        >
                          <FaEllipsisH
                            color="#0D6EFD"
                            size={20}
                            className="me-2"
                          />
                          Awaiting CDQ response
                        </Dropdown.Item>
                      </span>
                    {/* </Tooltip> */}
                    <Dropdown.Item>
                      <BiMoney size={20} color="#0d6efd" className="me-2" />
                      Sending for billing
                    </Dropdown.Item>
                    <Divider sx={{ border: "1px solid black" }} />
                    {(currentScreen === "auditorPage"
                      ? auditorOptions
                      : coderOptions
                    )?.map((item, index) => {
                      const isDisabledByOther =
                        selectedActionType === "forReview" ||
                        selectedActionType === "sendToAudit" ||
                        selectedActionType === "onHold";
                      return (
                        <Tooltip
                          key={item?.value || index}
                          // title={
                          //   isDisabledByOther
                          //     ? "Simultaneous actions cannot be performed at a time"
                          //     : (item?.value === "On Hold" ||
                          //           item?.value === "Audit - On Hold") &&
                          //         (!disableOnHold || !isEmpty)
                          //       ? "No codes available to put on hold"
                          //       : ""
                          // }
                          arrow
                          // disableHoverListener={
                            // !isDisabledByOther
                          // }
                        >
                          <span>
                            <Dropdown.Item
                              disabled={
                                !(
                                  (currentScreen === "auditorPage" &&
                                    (item?.value === "Audited" ||
                                      item?.value === "Audit - On Hold")) ||
                                  (currentScreen === "coderview" &&
                                    item?.value === "On Hold")
                                )
                                // item?.value === "Audited"
                                // selectedActionType === "onHold" ||
                                // selectedActionType === "forReview"
                              }
                              // style={{
                              //   opacity: isDisabledByOther ? 0.5 : 1,
                              // }}
                              onClick={() => {
                                setSelectedActionType("onHold");
                                handleSendToAudit(item.value);
                              }}
                            >
                              {item?.label}
                            </Dropdown.Item>
                          </span>
                        </Tooltip>
                      );
                    })}
                    {!(codebooksanEnv || codebooksanprodEnv) && (
                      <div className="dropdown-submenu-myactions">
                        <Tooltip
                          // title={
                          //   selectedActionType === "onHold" ||
                          //     selectedActionType === "Audit - On Hold" ||
                          //     selectedActionType === "forReview"
                          //     ? "Simultaneous actions cannot be performed at a time"
                          //     : ""
                          // }
                          // arrow
                          // disableHoverListener={
                          //   !(
                          //     selectedActionType === "onHold" ||
                          //     selectedActionType === "forReview"
                          //   )
                          // }
                        >
                          <Dropdown.Item
                            className="submenu-title"
                            // disabled={
                            //   selectedActionType === "onHold" ||
                            //   selectedActionType === "forReview"
                            // }
                          >
                            Send to Audit{" "}
                            <span className="submenu-arrow">▶</span>
                          </Dropdown.Item>
                        </Tooltip>
                        {/* {!(
                          selectedActionType === "onHold" ||
                          selectedActionType === "forReview"
                        ) && (
                           
                          )} */}
                           <Dropdown.Menu className="submenu-menu">
                              {/* Tabs */}
                              <div className="submenu-tabs">
                                <button
                                  className={
                                    activeTab === "queues" ? "active" : ""
                                  }
                                  onClick={() => setActiveTab("queues")}
                                >
                                  Queues
                                </button>

                                <button
                                  className={
                                    activeTab === "auditors" ? "active" : ""
                                  }
                                  onClick={() => setActiveTab("auditors")}
                                >
                                  Auditors
                                </button>
                              </div>

                              <div className="submenu-content">
                                {/* ================= QUEUES ================= */}
                                {activeTab === "queues" && (
                                  <>
                                    <Dropdown.Header>Queues</Dropdown.Header>

                                    <input
                                      className="submenu-search-input"
                                      placeholder="Search queues..."
                                      value={searchQueues}
                                      onChange={(e) =>
                                        setSearchQueues(e.target.value)
                                      }
                                    />

                                    <div className="submenu-column">
                                      {queues?.length ? (
                                        queues.map((q) => (
                                          <Dropdown.Item
                                            as="div"
                                            key={q.audit_queue_id}
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                              gap: 2,
                                            }}
                                          >
                                            <input
                                              type="checkbox"
                                              checked={selectedQueueIds.includes(
                                                q.audit_queue_id,
                                              )}
                                               
                                              onChange={(e) => {
                                                setSelectedAuditorId(null);
                                                setSelectedAuditorQueueIds([]);
                                                handleQueueToggle(
                                                  q.audit_queue_id,
                                                  e.target.checked,
                                                );
                                              }}
                                            />
                                            <span>{q.display_name}</span>
                                          </Dropdown.Item>
                                        ))
                                      ) :!queuesloading ? (
                                        <div className="no-results">
                                          No queues found
                                        </div>
                                      ):null}
                                        {queuesloading && (
           <div
          style={{
            display: "flex",
            justifyContent: "center",
            padding: "10px",
          }}
        >
          <CircularProgress size={20} />
        </div>
      )}
                                    </div>
                                  </>
                                )}

                                {/* ================= AUDITORS ================= */}
{activeTab === "auditors" && (
  <>
    {/* Auditors */}
    <Dropdown.Header>
      Auditors
    </Dropdown.Header>

    <input
      className="submenu-search-input"
      placeholder="Search auditor..."
      value={searchAuditor}
      onChange={(e) =>
        setSearchAuditor(e.target.value)
      }
    />

    <div
      className="submenu-column"
      style={{
        maxHeight: "100px",
        overflowY: "auto",
      }}
      onScroll={handleAuditorScroll}
    >
      {auditors?.length ? (
        auditors.map((a) => (
          <Tooltip
            key={a.user_id}
            title={
              a?.audit_queue?.length > 0
                ? a.audit_queue
                    .map((q) => q.display_name)
                    .join(", ")
                : "No queues assigned"
            }
            arrow
            placement="right"
          >
            <Dropdown.Item
              as="div"
              style={{
                display: "flex",
                alignItems: "center",
                gap: 2,
              }}
            >
              <input
                type="radio"
                name="auditor"
                checked={
                  selectedAuditorId ===
                  a.user_id
                }
                onChange={() => {
                  setSelectedQueueIds([]);
                  setSelectedAuditorQueueIds([]);
                  setSelectedAuditorId(
                    a.user_id
                  );
                  setAuditorForReviewId(
                    null
                  );
                  setCoderForReviewId(
                    null
                  );
                }}
              />

              <span>{a.user_name}</span>
            </Dropdown.Item>
          </Tooltip>
        ))
      ) : !queuesloading ? (
        <div className="no-results">
          No auditors found
        </div>
      ) : null}

      {queuesloading && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            padding: "10px",
          }}
        >
          <CircularProgress size={20} />
        </div>
      )}
    </div>

    {/* ================= AUDITOR QUEUES ================= */}

    <Dropdown.Header className="mt-2">
      Auditor Queues
    </Dropdown.Header>

    <input
      className="submenu-search-input"
      placeholder="Search auditor queues..."
      value={searchAuditorQueues}
      onChange={(e) =>
        setSearchAuditorQueues(
          e.target.value
        )
      }
    />

    <div className="submenu-column">
      {(() => {
        const selectedAuditor =
          auditors?.find(
            (a) =>
              a.user_id ===
              selectedAuditorId
          );

        const selectedAuditorQueueIdsFromApi =
          selectedAuditor?.audit_queue?.map(
            (q) => q.audit_queue_id
          ) || [];

        return masterQueues
          ?.filter((q) =>
            q.audit_queue_name
              ?.toLowerCase()
              ?.includes(
                searchAuditorQueues.toLowerCase()
              )
          )
          ?.map((q) => {
            const alreadyAssigned =
              selectedAuditorQueueIdsFromApi.includes(
                q.audit_queue_id
              );

            return (
              <Dropdown.Item
                as="div"
                key={q.audit_queue_id}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  backgroundColor:
                    alreadyAssigned
                      ? "#e8f5e9"
                      : "transparent",
                  borderRadius: "4px",
                  marginBottom: "2px",
                }}
              >
                <input
                  type="checkbox"
                  checked={   alreadyAssigned ||
                    selectedAuditorQueueIds?.includes(
                      q.audit_queue_id
                    )
                  }
                  onChange={(e) =>
                    handleAuditorQueueToggle(
                      q.audit_queue_id,
                      e.target.checked
                    )
                  }
                />

                <span>
                  {q.display_name}
                </span>
              </Dropdown.Item>
            );
          });
      })()}
    </div>
    
  </>
)}

                              {/* Footer */}
                              <div className="submenu-footer">
                                <button
                                  // onClick={handleSendToAudit}
                                  className="send-to-review-btn"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    // Only validate when in auditors tab
                                    if (
                                      activeTab === "auditors" &&
                                      !selectedAuditorQueueIds?.length
                                    ) {
                                      alert("Please select auditor queue");
                                      return;
                                    }

                                    setSelectedActionType("sendToAudit");
                                    handleSendToAudit();
                                    setSelectedAuditorQueueIds([]);
                                    setSelectedAuditorId(null);
                                  }}
                                >
                                  Send
                                </button>
                                <button
                                  className="send-to-reset-btn"
                                  onClick={() => {
                                    setSelectedQueueIds([]);
                                    setSelectedAuditorQueueIds([]);
                                    setSelectedAuditorId(null);
                                  }}
                                >
                                  Reset
                                </button>
                              </div>
                              </div>
                            </Dropdown.Menu>
                      </div>
                    )}

                    <Dropdown.Item disabled>For follow up</Dropdown.Item>

                    <div
                      className="dropdown-submenu-myactions"
                      // style={{
                      //   opacity:
                      //     selectedActionType === "onHold" ||
                      //       disableOnHold ||
                      //       isEmpty ||
                      //       (selectedActionType === "forReview" &&
                      //         newlyInsertedCodes.length === 0) ||
                      //       (hasAwaitingAudit &&
                      //         newlyInsertedCodes.length === 0 &&
                      //         deletedCodes.length === 0) ||
                      //       selectedActionType === "sendToAudit" ||
                      //       !canSendForReview() // ← Add this condition
                      //       ? 0.5
                      //       : 1,
                      // }}
                    >
                      <Tooltip
                        // title={
                        //   selectedActionType === "forReview"
                        //     ? "Episode cannot be sent for review at a time for multiple users.Please reopen the episode to perform another action"
                        //     : !canSendForReview()
                        //       ? "For Review is only available for episodes which are grouped or regrouped. Please group(confirm the DRG) the episode to enable this action"
                        //       : disableOnHold
                        //         ? "No codes available to send for review"
                        //         : selectedActionType === "onHold" ||
                        //           selectedActionType === "Audit - On Hold" ||
                        //           selectedActionType === "sendToAudit"
                        //           ? "Simultaneous actions cannot be performed at a time"
                        //           : ""
                        // }
                        arrow
                        // disableHoverListener={
                        //   !(
                        //     !canSendForReview() ||
                        //     disableOnHold ||
                        //     selectedActionType === "onHold" ||
                        //     selectedActionType === "sendToAudit" ||
                        //     (selectedActionType === "forReview" &&
                        //       newlyInsertedCodes.length === 0) ||
                        //     selectedActionType === "Audit - On Hold" ||
                        //     (hasAwaitingAudit &&
                        //       newlyInsertedCodes.length === 0 &&
                        //       deletedCodes.length === 0)
                        //   )
                        // }
                      >
                        <span>
                          <Dropdown.Item
                            className="submenu-title"
                            // disabled={
                            //   selectedActionType === "onHold" ||
                            //   disableOnHold ||
                            //   isEmpty ||
                            //   (selectedActionType === "forReview" &&
                            //     newlyInsertedCodes.length === 0) ||
                            //   !canSendForReview() // ← Add this condition
                            // }
                          >
                            {currentScreen === "auditorPage"
                              ? "Audit - For Review"
                              : "For Review"}
                            <span className="submenu-arrow">▶</span>
                          </Dropdown.Item>
                        </span>
                      </Tooltip>
                      {/* {!(
                        selectedActionType === "onHold" ||
                        (selectedActionType === "forReview" &&
                          newlyInsertedCodes.length === 0) ||
                        selectedActionType === "sendToAudit" ||
                        disableOnHold ||
                        !canSendForReview() ||
                        (hasAwaitingAudit &&
                          newlyInsertedCodes.length === 0 &&
                          deletedCodes.length === 0)
                      ) && ( */}
                          <Dropdown.Menu
                            autoClose="outside"
                            className="submenu-menu"
                          >
                            {/* Tabs */}
                            <div className="submenu-tabs">
                              <button
                                className={
                                  activeUserTab === "coders" ? "active" : ""
                                }
                                onClick={() => setActiveUserTab("coders")}
                              >
                                Coders
                              </button>

                              <button
                                className={
                                  activeUserTab === "auditors" ? "active" : ""
                                }
                                onClick={() => setActiveUserTab("auditors")}
                              >
                                Auditors
                              </button>
                            </div>

                            <div className="submenu-content">
                              {/* ================= CODERS ================= */}
                              {activeUserTab === "coders" && (
                                <>
                                  <Dropdown.Header>Coders</Dropdown.Header>

                                  <input
                                    className="submenu-search-input"
                                    placeholder="Search coders..."
                                    value={searchCoders}
                                    onChange={(e) =>
                                      setSearchCoders(e.target.value)
                                    }
                                  />

                                  <div className="submenu-column"
                                    onScroll={handleCoderScroll}
                                    style={{
                                      maxHeight: "100px",
                                      overflowY: "auto",
                                    }}>
                                    {filteredCoders?.length ? (
                                      filteredCoders.map((coder) => (
                                        <Dropdown.Item
                                          as="div"
                                          key={coder.user_id}
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 2,
                                          }}
                                        >
                                          <input
                                            type="radio"
                                            name="user"
                                            value={coder.user_id}
                                            checked={
                                              coderForReviewId === coder.user_id
                                            } // Now works with null comparison
                                            onChange={(e) => {
                                              setCoderForReviewId(
                                                Number(e.target.value),
                                              );
                                              setSelectedAuditorId(null);
                                              setAuditorForReviewId(null);
                                            }}
                                          />
                                          <span>{coder.user_name}</span>
                                        </Dropdown.Item>
                                      ))
                                    ) : !coderLoading ? (
                                      <div className="no-results">
                                        No coders found
                                      </div>
                                    ) : null}
                                    {coderLoading && (
                                      <div
                                        style={{
                                          display: "flex",
                                          justifyContent: "center",
                                          padding: "10px",
                                        }}
                                      >
                                        <CircularProgress size={20} />
                                      </div>
                                    )}
                                  </div>
                                </>
                              )}

                              {/* ================= AUDITORS ================= */}
                              {activeUserTab === "auditors" && (
                                <>
                                  <Dropdown.Header>Auditors</Dropdown.Header>

                                  <input
                                    className="submenu-search-input"
                                    placeholder="Search auditors..."
                                    value={searchAuditor}
                                    onChange={(e) => setSearchAuditor(e.target.value)}
                                  />

                                  <div className="submenu-column"
                                    style={{
                                      maxHeight: "100px",
                                      overflowY: "auto",
                                    }}
                                    onScroll={handleAuditorScroll}>
                                    {auditorsData?.length ? (
                                      auditorsData.map((auditor) => (
                                        <Dropdown.Item
                                          as="div"
                                          key={auditor.user_id}
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 2,
                                          }}
                                        >
                                          <input
                                            type="radio"
                                            name="user"
                                            value={auditor.user_id}
                                            checked={
                                              auditorForReviewId ===
                                              auditor.user_id
                                            } // Now works with null comparison
                                            onChange={(e) => {
                                              setAuditorForReviewId(
                                                Number(e.target.value),
                                              );
                                              setSelectedAuditorId(null);
                                              setCoderForReviewId(null); // Set to null instead of []
                                            }}
                                          />
                                          <span>{auditor.user_name}</span>
                                        </Dropdown.Item>
                                      ))
                                    ) : !loading ? (
                                      <div className="no-results">
                                        No auditors found
                                      </div>
                                    ) : null}
                                    {loading && (
                                      <div
                                        style={{
                                          display: "flex",
                                          justifyContent: "center",
                                          padding: "10px",
                                        }}
                                      >
                                        <CircularProgress size={20} />
                                      </div>
                                    )}
                                  </div>
                                </>
                              )}
                            </div>

                            {/* ✅ TEXTAREA ONLY FOR REVIEW */}
                            {(coderForReviewId || auditorForReviewId) && (
                              <div style={{ padding: "8px" }}>
                                <textarea
                                  placeholder="Enter reason for review..."
                                  value={reviewReason}
                                  onChange={(e) =>
                                    setReviewReason(e.target.value)
                                  }
                                  rows={3}
                                  style={{
                                    width: "100%",
                                    fontSize: "12px",
                                    padding: "6px",
                                    borderRadius: "4px",
                                    border: "1px solid #ccc",
                                    resize: "none",
                                  }}
                                />
                              </div>
                            )}

                            {/* Footer */}
                            <div
                              className="submenu-footer"
                              onClick={(e) => e.stopPropagation()} // 🔥 important
                            >
                              <button
                                type="button"
                                className="send-to-review-btn"
                                disabled={
                                  (activeUserTab === "coders" &&
                                    !coderForReviewId) ||
                                  (activeUserTab === "auditors" &&
                                    !auditorForReviewId)
                                }
                                style={{
                                  opacity:
                                    (activeUserTab === "coders" &&
                                      !coderForReviewId) ||
                                      (activeUserTab === "auditors" &&
                                        !auditorForReviewId)
                                      ? 0.5
                                      : 1,
                                  cursor:
                                    (activeUserTab === "coders" &&
                                      !coderForReviewId) ||
                                      (activeUserTab === "auditors" &&
                                        !auditorForReviewId)
                                      ? "not-allowed"
                                      : "pointer",
                                }}
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                   
                                  // Additional validation
                                  if (
                                    activeUserTab === "coders" &&
                                    !coderForReviewId
                                  ) {
                                    alert("Please select a coder");
                                    return;
                                  }
                                  if (
                                    activeUserTab === "auditors" &&
                                    !auditorForReviewId
                                  ) {
                                    alert("Please select an auditor");
                                    return;
                                  }

                                  if (!reviewReason.trim()) {
                                    alert("Please enter reason");
                                    return;
                                  }

                                  handleSendToAudit("AuditForReview", true);
                                  // handleSendToAudit();
                                }}
                              >
                                Send
                              </button>
                              <button
                                type="button"
                                className="send-to-reset-btn"
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  setSelectedCoderInActionId(null);
                                  setSelectedAuditorId(null);
                                  setCoderForReviewId(null); // Changed from [] to null
                                  setAuditorForReviewId(null); // Changed from [] to null
                                  setReviewReason("");
                                }}
                              >
                                Reset
                              </button>
                            </div>
                          </Dropdown.Menu>
                        {/* )} */}
                    </div>

                    {(currentScreen === "coderview" ||
                      currentScreen === "auditorPage") && (
                      <div className="dropdown-submenu-myactions">
                        <Tooltip
                          // title={
                          //   disableOnHold
                          //     ? "No codes available for missing notes"
                          //     : ""
                          // }
                          arrow
                          // disableHoverListener={!disableOnHold}
                        >
                          <span>
                            <Dropdown.Item
                              className="submenu-title"
                              // disabled={disableOnHold}
                              // style={{ opacity: disableOnHold ? 0.5 : 1 }}
                            >
                              Missing Notes{" "}
                              <span className="submenu-arrow">▶</span>
                            </Dropdown.Item>
                          </span>
                        </Tooltip>
                        {(
                          <Dropdown.Menu
                            autoClose="outside"
                            className="submenu-menu"
                          >
                            <div style={{ padding: "0.5rem", width: "250px" }}>
                              <div
                                style={{ maxHeight: "200px", overflow: "auto" }}
                              >
                                {missingNotesOptions.map((option) => (
                                  <div
                                    key={option.value}
                                    onClick={(e) => e.stopPropagation()}
                                    style={{ marginBottom: "0.5rem" }}
                                  >
                                    <Form.Check
                                      type="checkbox"
                                      className="missing_notest_checkbox"
                                      label={option.label}
                                      checked={selectedMissingNotesOptions?.reasons?.includes(
                                        option.value,
                                      )}
                                      onChange={() =>
                                        handleCheckboxChange(option.value)
                                      }
                                    />

                                      {option.value === "Other (specify)" &&
                                        selectedMissingNotesOptions?.reasons?.includes(
                                          "Other (specify)",
                                        ) && (
                                          <textarea
                                            value={
                                              selectedMissingNotesOptions
                                                .additional_comments[
                                              selectedMissingNotesOptions.reasons.indexOf(
                                                "Other (specify)",
                                              )
                                              ] || ""
                                            }
                                            onChange={(e) => {
                                              const updatedComments = [
                                                ...selectedMissingNotesOptions.additional_comments,
                                              ];

                                              const index =
                                                selectedMissingNotesOptions.reasons.indexOf(
                                                  "Other (specify)",
                                                );

                                              updatedComments[index] =
                                                e.target.value;

                                              dispatch(
                                                setSelectedMissingNotesOptions({
                                                  ...selectedMissingNotesOptions,
                                                  additional_comments:
                                                    updatedComments,
                                                }),
                                              );
                                            }}
                                            rows={3}
                                            style={{
                                              width: "100%",
                                              marginTop: "6px",
                                            }}
                                          />
                                        )}
                                    </div>
                                  ))}
                                </div>

                                <div className="submenu-footer">
                                  <button
                                    className="send-to-review-btn"
                                    disabled={
                                      !selectedMissingNotesOptions?.reasons
                                        ?.length
                                    }
                                    onClick={() => {
                                      handleSendToAudit("missingNotes", true);
                                      setShowMissingNotes(false);
                                    }}
                                  >
                                    Send
                                  </button>
                                  <button
                                    className="send-to-reset-btn"
                                    onClick={() => {
                                      dispatch(
                                        resetSelectedMissingNotesOptions(),
                                      );
                                      dispatch(setEnableMissingNotes(false));
                                    }}
                                  >
                                    Reset
                                  </button>
                                </div>
                              </div>
                            </Dropdown.Menu>
                          )}
                        </div>
                      )}
                  </Dropdown.Menu>
                </Dropdown>
              </Grid>
              <Grid
                sx={{
                  mt: { lg: 0, md: 0, sm: 0, xs: 1 },
                  mb: { lg: 0 },
                  ml: { lg: 1, md: 0, sm: 0, xs: 0 },
                  mr: { lg: 0 },
                }}
                className="my-actions-div"
              >
                {/* <Box
                  sx={{
                    backgroundColor: "#c2e7ff",
                    color: "#344054",
                    borderRadius: "5px",
                    fontSize: "14px",
                    fontWeight: "500",
                    padding: "9px 12px",
                    textAlign: "center",
                  }}
                  className="status-value"
                >
                  {currentStatus
                    ? currentStatus
                    : currentEpisode?.status
                      ? currentEpisode?.status
                      : "Status"}
                </Box> */}
                <Box
                  sx={{
                    position: "relative",
                    // width: "200px",

                    "&:hover .hover-list": {
                      display: "block",
                    },
                  }}
                >
                  {/* stacked layers */}
                  {list.slice(1, 3).map((_, index) => (
                    <Box
                      key={index}
                      sx={{
                        position: "absolute",
                        top: `${(index + 1) * 4}px`,
                        left: `${(index + 1) * 4}px`,
                        width: "100.5%",
                        height: "38px",
                        borderRadius: "6px",
                        backgroundColor: "#ccc",
                        zIndex: index,
                      }}
                    />
                  ))}

                  {/* top card (PRIMARY STATUS FIRST) */}
                  <Box
                    sx={{
                      position: "relative",
                      zIndex: 10,
                      backgroundColor: "#c2e7ff",
                      color: "#344054",
                      borderRadius: "6px",
                      fontSize: "14px",
                      fontWeight: "500",
                      padding: "10px",
                      textAlign: "center",
                      boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                    }}
                  >
                    {topStatus}
                  </Box>

                  {/* hover vertical list */}
                  {hasMultiple && (
                    <Box
                      className="hover-list"
                      sx={{
                        display: "none",
                        position: "absolute",
                        top: "45px",
                        left: 0,
                        width: "100%",
                        backgroundColor: "#fff",
                        border: "1px solid #e0e0e0",
                        borderRadius: "6px",
                        boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                        zIndex: 100,
                      }}
                    >
                      {list.map((status, index) => (
                        <Box
                          key={index}
                          sx={{
                            padding: "8px",
                            fontSize: "13px",
                            borderBottom:
                              index !== list.length - 1
                                ? "1px solid #eee"
                                : "none",
                            "&:hover": {
                              backgroundColor: "#f5f5f5",
                            },
                          }}
                        >
                          {typeof status === "string" ? status : status?.status}
                        </Box>
                      ))}
                    </Box>
                  )}
                </Box>
              </Grid>
              <Grid>{islockedKeyforepisode && <LockOutlineIcon />}</Grid>
            </Grid>
          </Grid>

          <Grid
            sx={{
              display: {
                lg: "flex",
                md: "flex",
                sm: "flex",
                xs: "block",
              },
              justifyContent: {
                lg: "space-between",
                md: "space-between",
                xs: "space-between",
              },
              mt: {
                xl: 0,
                lg: 0,
                md: 0,
                sm: 1,
                xs: 1,
              },
              alignItems: "center",
            }}
            className={location.pathname === "/coder" && "drg-opt-wrapper"}
          >
            <Grid
              sx={{
                ml: {
                  lg: 0,
                  xs: 0,
                },
                mt: { xs: 1 },
                mb: { xs: 1 },
                mr: { lg: 1 },
                display: "flex",
                justifyContent: "space-between",

                alignItems: {
                  lg: "center",
                  xs: "center",
                },
              }}
            >
              {/* Drgoption drop down */}
              {typeOfPatient !== "outPatient" && (
                <Box
                  className="drg-header"
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <span
                    className="drg-options"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      background: "#349ad7",
                      padding: ".3rem",
                      color: "#fff",
                      border: "1px solid gray",
                      borderRadius: ".5rem",
                      minWidth: "135px",
                      marginBottom: ".1rem",
                      textAlign: "center",
                    }}
                    onClick={handleDRGOptions}
                  >
                    <Typography
                      sx={{
                        fontSize: {
                          lg: "12px",
                          md: "12px",
                          xs: "11px",
                        },
                        fontWeight: "500",
                        marginRight: "6px",
                      }}
                      className="drg-title"
                    >
                      DRG Options
                      {/* <FaCog className="settings-icon" /> */}
                      <BsToggles
                        style={{
                          margin: "0 .5rem",
                          fontSize: ".9rem",
                        }}
                      />
                    </Typography>
                  </span>

                  {process.env.REACT_APP_FLAG_USA ? (
                    // ---------------------- USA MODE → SHOW BUTTON ----------------------
                    <button
                      style={{
                        fontSize: "13px",
                        background: "#349ad7",
                        padding: ".3rem",
                        color: "#fff",
                        border: "1px solid gray",
                        borderRadius: ".5rem",
                        minWidth: "135px",
                        marginTop: ".1rem",
                        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                        cursor: "pointer",
                      }}
                    >
                      Version 43
                    </button>
                  ) : (
                    // ------------------- NON-USA MODE → SHOW DROPDOWN -------------------
                    <Dropdown>
                      <Dropdown.Toggle
                        className="drgVersionsDropdown"
                        style={{
                          fontSize: "13px",
                          background: "#349ad7",
                          padding: ".3rem",
                          color: "#fff",
                          border: "1px solid gray",
                          borderRadius: ".5rem",
                          minWidth: "135px",
                          marginTop: ".1rem",
                          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                        }}
                        variant="secondary"
                      >
                        {selectedVersion
                          ? `AR-DRG V ${selectedVersion}`
                          : "Select Version"}
                      </Dropdown.Toggle>

                      {drgData?.grouper_versions && (
                        <Dropdown.Menu
                          style={{
                            fontSize: "13px",
                            width: "100%",
                            minWidth: "135px",
                            maxHeight: "300px",
                            overflowY: "auto",
                            border: "1px solid #e0e0e0",
                            borderRadius: "8px",
                            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                          }}
                        >
                          {drgData.grouper_versions
                            .filter((item) => item !== selectedVersion)
                            .map((item, index) => (
                              <Dropdown.Item
                                key={index}
                                as="button"
                                onClick={() => handleSelect(item)}
                                active={selectedVersion === item}
                                style={{
                                  fontSize: "13px",
                                  backgroundColor:
                                    selectedVersion === item
                                      ? "#e3f2fd"
                                      : "transparent",
                                  fontWeight:
                                    selectedVersion === item ? "600" : "400",
                                }}
                              >
                                AR-DRG V {item}
                              </Dropdown.Item>
                            ))}
                        </Dropdown.Menu>
                      )}
                    </Dropdown>
                  )}
                </Box>
              )}
              {/* end drg drop down */}
            </Grid>
            {typeOfPatient !== "outPatient" && (
              <Grid>
                {drgloading ? (
                  <Box
                    className="loading-div-wrapper"
                    sx={{
                      backgroundColor: "#0D3B66 !important",
                      borderRadius: "12px",
                      color: "white",
                      fontSize: "13px",
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      mt: { sm: 1, xs: 1 },
                      minHeight: "3.8rem !important",
                      maxHeight: "3.8rem !important",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: {
                          lg: "13px",
                          md: "13px",
                          xs: "12px",
                        },
                        marginBottom: "0px",
                      }}
                    >
                      Updating
                    </Typography>
                    <DotsLoader />
                  </Box>
                ) : (
                  <Dropdown
                    className="drg-dropdown"
                  // onClick={handleDrgInformation}
                  >
                    {["960Z", "961Z", "963Z"].includes(selectedDrgData?.drg) ? (
                      // Show this for error DRG codes

                      <div className="drg-error-block">
                        <FormControlLabel
                          sx={{
                            margin: 0,
                            gap: 1,
                            "& .MuiFormControlLabel-label": {
                              fontSize: "13px",
                              fontWeight: 500,
                              color: "#374151",
                            },
                          }}
                          control={
                            <Tooltip
                              title={
                                !isPallasAlgoApplied
                                  ? "Enable to view optimized DRG indicators."
                                  : ""
                              }
                              arrow
                              disableHoverListener={isPallasAlgoApplied} // disables when ON
                            >
                              <Switch
                                size="small"
                                checked={isPallasAlgoApplied}
                                onChange={(e) => {
                                  const checked = e.target.checked;

                                  if (checked) {
                                    handleRunDrgAlgorithm();
                                  } else {
                                    dispatch(resetIsPallasAlgoApplied());
                                    sessionStorage.removeItem(
                                      "pallas_session_token",
                                    );
                                  }
                                }}
                              />
                            </Tooltip>
                          }
                        />
                        <div className="d-flex gap-2">
                          <Typography
                            sx={{
                              display: "flex !important",
                              alignItems: "center",
                              fontSize: {
                                lg: "13px",
                                md: "13px",
                                xs: "12px",
                              },
                              minHeight: "2.5rem !important",

                              maxHeight: "2.5rem !important",

                              color: "red",
                            }}
                          >
                            {selectedDrgData?.drg}
                          </Typography>
                          {drgLabels[selectedDrgData?.drg] && (
                            <Typography
                              sx={{
                                display: "flex !important",
                                alignItems: "center",
                                fontSize: {
                                  lg: "13px",
                                  md: "13px",
                                  xs: "12px",
                                },
                                fontWeight: "bold",
                              }}
                            >
                              {drgLabels[selectedDrgData?.drg]}
                            </Typography>
                          )}
                        </div>
                      </div>
                    ) : (
                      // Show this for normal DRG codes
                      <div
                        variant="dark"
                        className={`drg-button ${isPallasAlgoApplied
                            ? selectedDrgData?.additional_information
                              ?.pallas_priority === "High"
                              ? "high"
                              : selectedDrgData?.additional_information
                                ?.pallas_priority === "Ultra High"
                                ? "ultrahigh"
                                : !isEmpty &&
                                  !selectedDrgData?.additional_information
                                    ?.pallas_priority
                                  ? "pallasoptimized"
                                  : ""
                            : ""
                          }`}
                      >
                        <FormControlLabel
                          sx={{
                            margin: 0,
                            gap: 1,
                            "& .MuiFormControlLabel-label": {
                              fontSize: "13px",
                              fontWeight: 500,
                              color: "#374151",
                            },
                          }}
                          control={
                            <Tooltip
                              title={
                                !isPallasAlgoApplied
                                  ? "Enable to view optimized DRG indicators."
                                  : ""
                              }
                              arrow
                              disableHoverListener={isPallasAlgoApplied} // disables when ON
                            >
                              <Switch
                                size="small"
                                checked={isPallasAlgoApplied}
                                onChange={(e) => {
                                  const checked = e.target.checked;

                                  if (checked) {
                                    handleRunDrgAlgorithm();
                                  } else {
                                    dispatch(resetIsPallasAlgoApplied());
                                    sessionStorage.removeItem(
                                      "pallas_session_token",
                                    );
                                  }
                                }}
                              />
                            </Tooltip>
                          }
                        />
                        <Box
                          className="drg-info"
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            minHeight: "3rem !important",

                            maxHeight: "3rem !important",
                            // marginTop:".7rem"
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: {
                                lg: "13px",
                                md: "13px",
                                xs: "12px",
                              },
                              marginTop: ".3rem",
                            }}
                            className="drg-key"
                          >
                            DRG
                          </Typography>
                          {drgloading ? (
                            <BiLoader />
                          ) : (
                            <Typography
                              variant="body2"
                              className="drg-key"
                              sx={{
                                fontSize: {
                                  lg: "13px",
                                  md: "13px",
                                  xs: "12px",
                                },
                              }}
                            >
                              {selectedDrgData?.drg
                                ? selectedDrgData?.drg
                                : "-"}
                            </Typography>
                          )}
                        </Box>
                        <Box
                          className="drg-info"
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: {
                                lg: "13px",
                                md: "13px",
                                xs: "12px",
                              },
                            }}
                            className="drg-key"
                          >
                            Weight
                          </Typography>
                          {drgloading ? (
                            <BiLoader />
                          ) : selectedDrgData?.weight === "can't determine" ? (
                            <span className="drg-value">-</span>
                          ) : (
                            <Typography
                              sx={{
                                fontSize: {
                                  lg: "13px",
                                  md: "13px",
                                  xs: "12px",
                                },
                              }}
                              className="drg-value"
                            >
                              {selectedDrgData?.weight
                                ? selectedDrgData?.weight?.toFixed(4)
                                : "-"}
                            </Typography>
                          )}
                        </Box>
                        <Box
                          className="drg-info"
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: {
                                lg: "13px",
                                md: "13px",
                                xs: "12px",
                              },
                            }}
                            className="drg-key"
                          >
                            Reimbursement
                          </Typography>
                          {drgloading ? (
                            <BiLoader />
                          ) : weightValue === "can't determine" ? (
                            <span className="drg-value">-</span>
                          ) : (
                            <Typography
                              variant="body2"
                              sx={{
                                fontSize: {
                                  lg: "13px",
                                  md: "13px",
                                  xs: "12px",
                                },
                              }}
                              className="drg-value"
                            >
                              {selectedDrgData?.weight === "can't determine" ||
                                !selectedDrgData?.weight
                                ? "-"
                                : codebookusaEnv
                                  ? `$${Math.round(
                                    selectedDrgData?.reimbursement,
                                  ).toLocaleString()}`
                                  : `$${Math.round(
                                    selectedDrgData?.weight * 6465,
                                  ).toLocaleString()}`}
                            </Typography>
                          )}
                        </Box>
                        <Dropdown.Toggle
                          variant="dark"
                          className="drg-dropdown-arrow"
                          onMouseDown={handleDrgInformation}
                        >
                          {/* Just the arrow icon */}
                        </Dropdown.Toggle>
                      </div>
                    )}

                    <Dropdown.Menu className="drg-menu">
                      {drgloading ? (
                        <Typography
                          sx={{
                            fontSize: {
                              lg: "13px",
                              md: "13px",
                              xs: "12px",
                            },
                          }}
                        >
                          Loading...
                        </Typography>
                      ) : (
                        <div>
                          <div className="drg-item">
                            <div className="drg-label">
                              {selectedDrgData?.drg}
                            </div>
                            <img src={drg1Icon} alt="" className="drg-icon" />
                            <div className="drg-detail">
                              {/* <FaNotesMedical className="drg-icon" /> */}
                              {
                                selectedDrgData?.additional_information
                                  ?.description
                              }
                              <Box
                                sx={{
                                  fontFamily: {
                                    sm: "11px",
                                  },
                                }}
                              >
                                {" "}
                                Inlier Wgt{" "}
                                {
                                  selectedDrgData?.additional_information
                                    ?.inlier
                                }{" "}
                                Lower Bound{" "}
                                {
                                  selectedDrgData?.additional_information
                                    ?.lower_bound
                                }{" "}
                                Upper Bound{" "}
                                {
                                  selectedDrgData?.additional_information
                                    ?.upper_bound
                                }{" "}
                                Same Day{" "}
                                {
                                  selectedDrgData?.additional_information
                                    ?.same_day
                                }{" "}
                                ALOS{" "}
                                {selectedDrgData?.additional_information?.alos}
                              </Box>
                            </div>
                          </div>

                          {!codebookusaEnv && (
                            <div className="drg-item">
                              <div className="drg-label">
                                {/* {selectedDrgData?.additional_information?.eccs} */}
                                {Number(selectedDrgData?.additional_information?.eccs).toFixed(1)}
                              </div>
                              <img src={drg4Icon} alt="" className="drg-icon" />
                              <div className="drg-detail">
                                Episode Clinical Complexity Score
                              
                                {selectedDrgData?.additional_information?.eccs_criteria?.length > 0 ? (
                                  selectedDrgData.additional_information.eccs_criteria?.map((item, index) => (
                                    <div
                                      key={`${item?.complexity || "unknown"}-${index}`}
                                      style={{ display: "flex", gap: "12px" }}
                                    >
                                      <span>{item?.complexity || "-"}</span>
                                      <span>
                                        {item?.criteria?.trim() ? item.criteria : "ECCS -"}
                                      </span>
                                    </div>
                                  ))
                                ) : (
                                  <span>No ECCS criteria available</span>
                                )}
                                {/* <p>B&nbsp;&nbsp; ECCS &lt; 2.5</p> */}
                              </div>
                            </div>
                          )}

                          {!codebookusaEnv && (
                            <div className="drg-item">
                              <div className="drg-label">
                                {
                                  selectedDrgData?.additional_information
                                    ?.mdc_code
                                }
                              </div>
                              <img src={drg3Icon} alt="" className="drg-icon" />
                              <div className="drg-detail">
                                {/* <FaClock className="drg-icon" /> */}
                                {
                                  selectedDrgData?.additional_information
                                    ?.mdc_description
                                }
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                    </Dropdown.Menu>
                  </Dropdown>
                )}
              </Grid>
            )}
          </Grid>
        </Grid>

        <Modal
          open={auditStatusChangeModal}
          onClose={() => setAuditStatusChangeModal(false)}
          aria-labelledby="episode-audit-log-title"
          aria-describedby="episode-audit-log-description"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: { xs: "90%", sm: 600 },
              bgcolor: "background.paper",
              boxShadow: 24,
              borderRadius: 2,
              p: 4,
              outline: "none",
            }}
          >
            {/* Header */}
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              mb={2}
            >
              <Typography
                id="episode-audit-log-title"
                variant="h6"
                fontWeight="bold"
                fontSize="16px"
              >
                Episode Audit Log
              </Typography>
              <IconButton onClick={() => setAuditStatusChangeModal(false)}>
                <CloseIcon />
              </IconButton>
            </Box>

            {/* Table Content */}
            <Box
              component="table"
              width="100%"
              sx={{
                borderCollapse: "collapse",
                mt: 1,
              }}
            >
              <tbody>
                {[
                  { label: "Time", value: auditStatusStateData?.TIME },
                  {
                    label: "Additional Diagnoses",
                    value: auditStatusStateData?.additional_diagnoses1,
                  },
                  { label: "DRG Code", value: auditStatusStateData?.drg_code },
                ].map(({ label, value }) => (
                  <TableRow key={label} label={label} value={value} />
                ))}
              </tbody>

              <tbody>
                {[
                  "principal_diagnosis_code",
                  "procedure_codes1",
                  "procedure_codes2",
                  "procedure_codes3",
                  "procedure_codes4",
                  "procedure_codes5",
                  "procedure_codes6",
                  "procedure_codes7",
                ].map((field, index) => (
                  <TableRow
                    key={field}
                    label={
                      index === 0
                        ? "Principal Diagnosis Code"
                        : `Procedure Code ${index}`
                    }
                    value={auditStatusStateData?.[field]}
                  />
                ))}
              </tbody>
            </Box>
          </Box>
        </Modal>

        {/* adding comment for the missing notes modal */}
        {/* <Modal
          open={missingNotesModal}
          onClose={() => setMissingNotesModal(false)}
          aria-labelledby="episode-audit-log-title"
          aria-describedby="episode-audit-log-description"
        >
            <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: { xs: "90%", sm: 600 },
              bgcolor: "background.paper",
              boxShadow: 24,
              borderRadius: 2,
              p: 4,
              outline: "none",
            }}
          >
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              mb={2}
            >
              <Typography
                id="episode-audit-log-title"
                variant="h6"
                fontWeight="bold"
                fontSize="16px"
              >
                Missing Notes
              </Typography>
              <IconButton onClick={() => setMissingNotesModal(false)}>
                <CloseIcon />
              </IconButton>
            </Box>

            <Box
              component="table"
              width="100%"
              sx={{
                borderCollapse: "collapse",
                mt: 1,
              }}
            >
            <TextField  
              multiline
              rows={4}sx={{
              width:"100%"
            }}
             id="outlined-basic" label="Comment" variant="outlined" />
            </Box>
            <Box sx={{display: 'flex', justifyContent: "end", alignItems: "center", marginTop: "10px"}}>
              <Button
                    onClick={handleOpen}
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      marginRight: "10px",
                      color: "white",
                      backgroundColor: '#349ad7'
                    }}
                    size="sm"
                    className="view-button"
                  >Add Comment</Button>
                  <Button
                    onClick={() => setMissingNotesModal(false)}
                    variant="outline-secondary"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    size="sm"
                    className="view-button"
                  >Cancel</Button>
            </Box>
          </Box>
        
        </Modal> */}
      </>
        {/* ✅ UPDATED: Available Queue Modal — uses clickedEpisodeQueues from showAvailableAuditQueues API */}
                <Modal
  open={showAuditQueueModal && !isLoadingQueues && clickedEpisodeQueues.length > 1}
  onClose={(event, reason) => {
    if (reason === "backdropClick" || reason === "escapeKeyDown") return;
  }}
>
  <div
    style={{
      position: "fixed",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      backgroundColor: "#fff",
      borderRadius: "8px",
      width: "480px",
      maxWidth: "90%",
      padding: "16px",
      boxShadow: "0 8px 24px rgba(0,0,0,0.2)",
      maxHeight: "80vh",
      overflowY: "auto",
    }}
  >
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "12px" }}>
      <Typography style={{ fontSize: "16px", fontWeight: 600 }}>
        Available Queue
      </Typography>
      <IconButton size="small" onClick={handleAuditQueueCloseIcon}>
        <CloseIcon fontSize="small" />
      </IconButton>
    </div>

    <div style={{ display: "flex", flexDirection: "column", gap: "16px", padding: "8px 0" }}>

      {/* ===== ASSIGNED USERS SECTION (from AuditorView + CoderView) ===== */}
      {clickedEpisodeQueues.some((q) => "assigned_user_id" in q && !q.assignment_reason?.trim()) && (
        <>
          <Typography style={{ fontSize: "14px", fontWeight: 600 }}>
            {clickedEpisodeQueues.every((q) => q.assigned_user_id === loginUserID)
              ? "Assigned to You"
              : clickedEpisodeQueues.some((q) => q.assigned_user_id === loginUserID)
              ? "Assigned to Team"
              : "Assigned to Others"}
          </Typography>
          <div style={{ display: "flex", flexWrap: "wrap", gap: "12px", justifyContent: "center" }}>
            {clickedEpisodeQueues
              .filter((q) => "assigned_user_id" in q && !q.assignment_reason?.trim())
              .map((queue, index) => (
                <button
                  key={queue.assigned_username || queue.queue_id || index}
                  type="button"
                  style={{
                    flex: "1 1 calc(50% - 12px)",
                    minWidth: "120px",
                    maxWidth: "calc(50% - 12px)",
                    padding: "8px",
                    borderRadius: "8px",
                    border: `1px solid ${selectedQueueworkSpace?.assigned_username === queue.assigned_username ? "#032f49" : "#e0e0e0"}`,
                    backgroundColor: selectedQueueworkSpace?.assigned_username === queue.assigned_username ? "#032f49" : "#fff",
                    color: selectedQueueworkSpace?.assigned_username === queue.assigned_username ? "#fff" : "#333",
                    cursor: "pointer",
                    textAlign: "left",
                    display: "flex",
                    flexDirection: "column",
                    gap: "4px",
                  }}
                  onClick={() => handleQueueSelect(queue)}
                >
                  <span style={{ fontWeight: "600", fontSize: "14px" }}>
                    {queue.assigned_username}
                  </span>
                  <span style={{ fontSize: "12px", opacity: 0.75 }}>
                    {queue.queue_name || ""}
                  </span>
                </button>
              ))}
          </div>
        </>
      )}

      {/* ===== FOR REVIEW SECTION (from AuditorView) ===== */}
      {clickedEpisodeQueues.some((q) => q.assignment_reason?.trim()?.length > 0) && (
        <>
          <Typography style={{ fontSize: "14px", fontWeight: 600 }}>
            For Review
          </Typography>
          <div style={{ display: "flex", flexWrap: "wrap", gap: "12px", justifyContent: "center" }}>
            {clickedEpisodeQueues
              .filter((q) => q?.assigned_user_id && q?.assignment_reason?.trim())
              .map((queue, index) => (
                <Tooltip
                  key={queue.queue_id || index}
                  title={
                    <div>
                      <div><b>User:</b> {queue.assigned_username || "-"}</div>
                      <div><b>Reason:</b> {queue.assignment_reason}</div>
                    </div>
                  }
                  arrow
                >
                  <button
                    type="button"
                    style={{
                      flex: "1 1 calc(50% - 12px)",
                      minWidth: "120px",
                      maxWidth: "calc(50% - 12px)",
                      padding: "8px",
                      borderRadius: "8px",
                      // border: `1px solid ${selectedQueueworkSpace?.queue_id === queue.queue_id ? "#032f49" : "#e0e0e0"}`,
                      // backgroundColor: selectedQueueworkSpace?.queue_id === queue.queue_id ? "#032f49" : "#fff",
                      // color: selectedQueueworkSpace?.queue_id === queue.queue_id ? "#fff" : "#333",
                      border: `1px solid ${
  selectedQueueworkSpace?.line_assignment_id === queue.line_assignment_id
    ? "#032f49"
    : "#e0e0e0"
}`,
backgroundColor:
  selectedQueueworkSpace?.line_assignment_id === queue.line_assignment_id
    ? "#032f49"
    : "#fff",
color:
  selectedQueueworkSpace?.line_assignment_id === queue.line_assignment_id
    ? "#fff"
    : "#333",
                      cursor: "pointer",
                      textAlign: "left",
                      display: "flex",
                      flexDirection: "column",
                      gap: "4px",
                    }}
                    onClick={() => handleQueueSelect(queue)}
                  >
                    <span style={{ fontWeight: "600", fontSize: "14px" }}>
                      {queue.assigned_username}
                    </span>
                    <span style={{ fontSize: "12px", opacity: 0.75 }}>
                      Reason: {queue.assignment_reason}
                    </span>
                  </button>
                </Tooltip>
              ))}
          </div>
        </>
      )}

      {/* ===== AVAILABLE QUEUES SECTION (normal queues without assigned_user_id) ===== */}
      {clickedEpisodeQueues.some((q) => !("assigned_user_id" in q)) && (
        <>
          <Typography style={{ fontSize: "14px", fontWeight: 600 }}>
            Available Queues
          </Typography>
          <div style={{ display: "flex", flexWrap: "wrap", gap: "12px", justifyContent: "center" }}>
            {clickedEpisodeQueues
              .filter((q) => !("assigned_user_id" in q))
              .map((queue) => (
                <button
                  key={queue.queue_id}
                  type="button"
                  style={{
                    flex: "1 1 calc(50% - 12px)",
                    minWidth: "120px",
                    maxWidth: "calc(50% - 12px)",
                    padding: "6px 8px",
                    borderRadius: "6px",
                    border: `2px solid ${selectedQueueworkSpace?.queue_id === queue.queue_id ? "#032f49" : "#dee2e6"}`,
                    backgroundColor: selectedQueueworkSpace?.queue_id === queue.queue_id ? "#032f49" : "transparent",
                    color: selectedQueueworkSpace?.queue_id === queue.queue_id ? "white" : "#212529",
                    fontWeight: "500",
                    cursor: "pointer",
                    fontSize: "14px",
                    textAlign: "center",
                    transition: "all 0.2s ease",
                    height: "48px",
                    boxSizing: "border-box",
                  }}
                  onClick={() => handleQueueSelect(queue)}
                >
                  {queue.queue_name}
                </button>
              ))}
          </div>
        </>
      )}

    </div>

    <div style={{ textAlign: "right", marginTop: "16px" }}>
      <button
        onClick={handleAuditQueueCloseIcon}
        style={{
          padding: "8px 16px",
          borderRadius: "6px",
          border: "none",
          backgroundColor: "rgb(52, 154, 215)",
          color: "#fff",
          cursor: "pointer",
        }}
      >
        OK
      </button>
    </div>
  </div>
</Modal>
    </Container>
  );
};

export default EpisodeStatus;
